const translations = {
  en: {
    // Login
    appName: 'My Personal Plant Inventory',
    appTagline: 'Your personal houseplant care companion.',
    appTagline2: 'Track, identify, and nurture your green friends.',
    signInPrompt: 'Sign in with Google to sync your plants across devices',
    localModeButton: "I'd rather not",
    localWarningTitle: 'Before continuing without an account:',
    continueLocalMode: 'Continue to local mode',
    cancelLocalMode: 'Cancel',
    // Library
    myPlants: 'My Plants',
    searchPlants: 'Search plants...',
    noPlants: 'No plants yet',
    noPlantsDesc: 'Tap the + button to add your first plant!',
    noResults: 'No plants match your search',
    incomplete: 'Incomplete',
    showing: 'Showing',
    of: 'of',
    plants: 'plants',
    plant: 'plant',
    // Add Plant
    addPlant: 'Add Plant',
    editPlant: 'Edit Plant',
    edit: 'Edit',
    bulkPhotoProgress: 'Add photo {n} of {total}',
    bulkPhotoCapped: 'Only {n} more photo(s) fit — the rest were skipped.',
    addPhoto: 'Add Photo',
    replacePhoto: 'Replace Photo',
    photoUpdated: 'Photo updated',
    photoAdded: 'Photo added',
    photoReplaced: 'Photo replaced',
    photoUpdateFailed: 'Failed to update photo',
    batchAdd: 'Batch Add',
    fromCamera: 'From Camera',
    mergeIntoAnother: "Merge into another plant",
    mergeDialogTitle: "Merge these two plants",
    mergeDialogBlurb: "The KEEPER stays in your library and absorbs everything from the other plant. Pick which value wins for each field. Photos combine up to 5 total.",
    mergeDialogBlurbV2: "Verify the common and scientific names match, choose which photos to keep, and pick a cover. The other one gets merged into it.",
    mergeKeeper: "Kept (stays)",
    mergeAbsorbedTitle: "Merged in (removed)",
    mergeAbsorbed: "Merged in",
    mergeKeepThis: "Kept",
    mergePhotos: "photo(s)",
    mergeConfirm: "Merge plants",
    mergeInProgress: "Merging…",
    mergeFailed: "Merge failed",
    mergeSuccess: "Plants merged.",
    mergeSuccessWithDrop: "Merged. {n} extra photo(s) discarded (5 max).",
    mergeSameError: "Can't merge a plant with itself.",
    mergeDiffHeader: "{n} care field(s) differ — pick one",
    mergeNoDiff: "The two plants have identical care info — nothing to reconcile.",
    mergePhotoWarning: "⚠ {n} extra photo(s) will be discarded (max 5 per plant).",
    mergeEmpty: "—",
    mergeAction: "Merge",
    mergePickerTitle: "Merge into another plant",
    mergePickerBlurb: "Choose the plant that stays. {name} will be merged into it.",
    mergePickerSearch: "Search by name…",
    mergePickerSuggested: "Likely duplicates",
    mergePickerEmpty: "No other plants match.",
    mergeSelected: "Merge selected",
    mergeRequiresTwo: "Select exactly 2 plants to merge",
    mergePlantsNotFound: "Selected plants not found",
    duplicateBadge: "Duplicate?",
    duplicateBannerBody: "Two entries share the name \"{name}\". Merge them?",
    duplicateBannerBodyFuzzy: "\"{a}\" and \"{b}\" look like the same plant. Merge them?",
    dupeReviewLater: 'Review later',
    dupeReviewLaterTip: 'Hide for now — review again later in Settings',
    dupeNotADuplicate: 'Not a duplicate',
    dupeNotADuplicateTip: 'These are definitely different plants — never suggest this pair again',
    dupePreviewNoPhotos: 'No photos',
    // Compare overlay (tap thumbs or Compare button on the auto-suggest banner)
    dupeCompare: 'Compare',
    dupeCompareTip: 'View both plants side-by-side before merging',
    dupeCompareOpen: 'Compare side by side',
    dupeCompareTitle: 'Compare plants',
    dupeCompareBlurb: 'Same plant? Tap Merge below. Different plants? Close and dismiss.',
    dupeCompareSwapHint: 'Swipe left/right to swap Kept vs Merged in',
    dupeCompareSwapHintSwapped: 'Swiped — swipe again to swap back',
    dupeCompareSwap: 'Swap Kept and Merged in',
    dupeCompareSwapTip: 'Swap which plant is Kept vs Merged in',
    // Reset all duplicate suggestions (owner-only)
    dupeResetToast: 'Cleared all duplicate suggestions — starting fresh',
    dupeResetConfirm: 'Clear {n} dismissed duplicate suggestions and start fresh?',
    dupeResetAll: 'Reset all duplicate suggestions',
    dupeResetBlurb: 'Wipes both the "Not a duplicate" and "Review later" lists so the banner starts flagging pairs again from scratch.',
    dupeReviewSettingsTitle: 'Review later — duplicate suggestions',
    dupeReviewSettingsBlurb: 'Pairs you asked to review later. Bring one back to the library banner or dismiss it permanently.',
    dupeReviewRestore: 'Bring back',
    dupeReviewEmpty: 'Nothing waiting for review.',
    dupeMarkAllNotDupe: 'Mark all as "Not a duplicate" ({n})',
    dupeMarkAllNotDupeConfirm: 'Mark all {n} pairs as "Not a duplicate"? They will not be suggested again.',
    dupeBannerToggleLabel: 'Suggest duplicate merges',
    dupeBannerToggleBlurb: 'When off, the library never shows the "possible duplicates" banner. Merging via bulk-edit or plant details still works.',
    dupeStrictnessLabel: 'Detection sensitivity',
    dupeStrictnessBalanced: 'Balanced',
    dupeStrictnessStrict: 'Strict',
    dupeStrictnessExact: 'Exact only',
    dupeStrictnessBalancedBlurb: 'Default. Suggests pairs whose names substantially overlap.',
    dupeStrictnessStrictBlurb: 'Both names must share most of their words (≥ 85%).',
    dupeStrictnessExactBlurb: 'Only suggests pairs with identical names. Nothing fuzzy.',
    dupeSnooze7d: 'Hide for 7 days',
    dupeSnooze1d: 'Hide for 1 day',
    dupeSnooze3d: 'Hide for 3 days',
    dupeSnooze30d: 'Hide for 30 days',
    dupeSnoozeMore: 'More snooze options',
    dupeSnoozeTip: 'Hide these suggestions for 7 days',
    dupeSnoozeToast: 'Duplicate suggestions hidden for {n} days',
    aiTipViewPlants: 'View plants',
    aiTipShowFamily: 'Show all {family} plants',
    aiTipFilterToast: 'Filtered to {family} ({count} plants). Tap × to clear.',
    aiTipSnoozeTip: 'Hide this suggestion for 7 days',
    aiTipSnooze1d: 'Hide for 1 day',
    aiTipSnooze3d: 'Hide for 3 days',
    aiTipSnooze7d: 'Hide for 7 days',
    aiTipSnooze30d: 'Hide for 30 days',
    aiTipSnoozeAll: 'Hide all suggestions for {n} days',
    aiTipSnoozeToast: 'Suggestion hidden for {n} days',
    aiTipSnoozeAllToast: 'All suggestions hidden for {n} days',
    familyFilterActive: 'Family: {family}',
    familyFilterClear: 'Clear family filter',
    snoozeDigestTitle: 'Snoozed suggestions',
    snoozeDigestBlurb: 'Suggestions you\u2019ve temporarily hidden. Un-hide any of them below.',
    snoozeDigestDupeLabel: 'Duplicate suggestions',
    snoozeDigestAllAiLabel: 'All AI suggestions',
    snoozeDigestAiTipLabel: 'AI tip \u00b7 {family}',
    snoozeDigestUntil: 'Returns {when}',
    snoozeDigestUnhide: 'Un-hide',
    snoozeDigestUnhideAll: 'Un-hide all',
    snoozeDigestUnhideToast: 'Suggestion re-enabled',
    snoozeDigestUnhideAllToast: 'Re-enabled {n} snoozed suggestions',
    langAutoDetectedChip: 'Language set to {language} \u2014 tap to switch back to English',
    langAutoDetectedChipDismiss: 'Dismiss language chip',
    langAutoDetectedSwitchToast: 'Language switched to English',
    langUnsupportedNote: 'Your device language ({locale}) isn\u2019t supported yet, so we\u2019re showing English. Pick a language above any time.',
    offlineBanner: 'You\u2019re offline \u2014 browsing your last saved library',
    offlineWriteBlocked: 'You\u2019re offline \u2014 reconnect to save changes.',
    offlineFallbackLoaded: 'Loaded {n} plants from your offline cache',
    lastSyncedLabel: 'Last synced',
    refreshNow: 'Refresh now',
    refreshSyncing: 'Refreshing\u2026',
    refreshOffline: 'You\u2019re offline \u2014 reconnect to refresh.',
    offlineCacheTitle: 'Offline cache',
    offlineCacheBlurb: 'A read-only copy of your library kept on this device so you can still browse when offline.',
    offlineCacheStats: '{count} {plantWord} \u00b7 {size} \u00b7 saved {when}',
    offlineCacheClear: 'Clear offline cache',
    offlineCacheCleared: 'Offline cache cleared',
    offlineCacheClearFailed: 'Could not clear the offline cache',
    pendingSyncPill: '{n} changes pending sync',
    pendingSyncPillOne: '1 change pending sync',
    pendingSyncTitle: 'Changes waiting to sync',
    pendingSyncBlurbOnline: 'These changes are saved on this device and will sync automatically.',
    pendingSyncBlurbOffline: 'You\u2019re offline. These will sync as soon as you reconnect.',
    pendingSyncRetry: 'Retry now',
    pendingSyncSyncing: 'Syncing\u2026',
    pendingSyncDiscard: 'Discard this change',
    pendingSyncDiscardAll: 'Discard all',
    pendingSyncDiscardAllConfirmTitle: 'Discard all pending changes?',
    pendingSyncDiscardAllConfirmBody: 'This removes {n} changes waiting to sync and reverts them on this device.',
    pendingSyncDiscardAllConfirmBodyOne: 'This removes 1 change waiting to sync and reverts it on this device.',
    pendingSyncDiscardAllToast: 'Discarded all pending changes',
    aboutTocTitle: 'On this page',
    pendingSyncViewDetails: 'Details',
    allChangesSynced: 'All changes synced',
    addOfflineNotice: 'You\u2019re offline — new plants need a connection. Edits, archives and deletes still work and sync when you\u2019re back.',
    pendingWaitingFor: 'waiting {time}',
    syncProgress: '{done} of {total} synced',
    syncHistoryTitle: 'Recent sync activity',
    syncHistoryClear: 'Clear',
    syncStatusSynced: 'Synced',
    syncStatusConflict: 'Conflict',
    syncStatusGaveup: 'Failed',
    syncStatusDiscarded: 'Discarded',
    discardUndo: 'Undo',
    changeDiscarded: 'Change discarded',
    syncSyncedOne: '1 change synced',
    syncSyncedMany: '{n} changes synced',
    syncConflictOne: 'Couldn\u2019t sync "{name}" \u2014 it was changed or removed on another device.',
    syncConflictMany: '{n} changes couldn\u2019t sync \u2014 those plants were changed or removed on another device.',
    syncGaveupOne: 'Gave up syncing "{name}" after several tries \u2014 please redo it.',
    syncGaveupMany: '{n} changes couldn\u2019t be saved after several tries and were dropped.',
    syncRetryOne: '1 change couldn\u2019t sync \u2014 will retry',
    syncRetryMany: '{n} changes couldn\u2019t sync \u2014 will retry',
    offlineHelpTitle: 'Offline & Sync',
    offlineHelpBody: 'Offline you can browse and edit, archive or delete plants — those changes queue and sync automatically when you reconnect. Adding a brand-new plant needs a connection.',
    offlineHelpLearnMore: 'Learn more',
    aboutSharingTitle: 'Sharing your plants',
    aboutSharingBody: 'Share a single plant as a rich image, or your whole library as a PDF — at a glance (photos + names), in full detail (a page per plant), or names only. Every library PDF includes a scannable QR code, a tappable link and your welcome note. Recipients open a read-only \u201cgrow-along\u201d view; nothing in your library changes and they can\u2019t edit it.',
    savedOfflineToast: 'Saved offline \u2014 will sync when you reconnect',
    offlineWriteBlocked: 'You\u2019re offline \u2014 reconnect to save changes.',
    pendingOpEdit: 'Edit \u201c{name}\u201d',
    pendingOpArchive: 'Archive \u201c{name}\u201d',
    pendingOpDelete: 'Delete \u201c{name}\u201d',
    pendingOpBulkUpdate: 'Update {count} {plantWord}',
    pendingOpBulkDelete: 'Delete {count} {plantWord}',
    pendingOpAddPhoto: 'Add photo to \u201c{name}\u201d',
    toastPositionLabel: 'Toast position',
    toastPositionTop: 'Top',
    toastPositionBottom: 'Bottom',
    toastPositionUpdated: 'Toast position updated',
    toastPositionBlurb: 'Where confirmation and error toasts appear on the screen.',
    toastPositionPreview: 'Sample toast — this is where notifications will appear',
    mergePhotoPickerHeader: 'Photos — pick which ones to keep ({sel}/{max})',
    mergePhotoPickerCoverHint: 'The starred photo will be the cover',
    mergePhotoLoading: 'Loading photos…',
    mergePhotoNone: 'Neither plant has any photos.',
    mergePhotoIsCover: 'Cover photo',
    mergePhotoMakeCover: 'Make cover',
    mergePhotoSelected: '✓ Keep',
    mergePhotoDeselected: 'Skip',
    mergePhotoAutoDrop: 'Max 5 photos — the oldest selection was unchecked.',
    mergePhotoWarningLocal: '⚠ {n} unchecked photo(s) will be removed with the merge.',
    mergePhotoWarningDrive: '⚠ {n} unchecked photo(s) will be orphaned (stay in Drive, not attached to any plant).',
    mergePhotoZoom: 'View larger',
    mergeUndoDone: 'Merge undone.',
    mergeUndoFailed: 'Undo failed',
    undo: 'Undo',
    fromGallery: 'From Gallery',
    enterManually: 'Enter manually without a photo',
    multiPhotoTitle: 'Add plant with multiple photos',
    multiPhotoDesc: 'Send several angles of the same plant so the AI identifies it more accurately. Up to 5 photos.',
    multiPhotoProgress: 'Photo {n} of {total} — crop each one, then AI identifies from all',
    retryIdentifyBlurb: "AI couldn't identify your plant. Try again with the same photos?",
    retryIdentify: 'Try AI again',
    retryingIdentify: 'Retrying…',
    doneCropping: 'Done Cropping',
    rotate: 'Rotate',
    cancel: 'Cancel',
    skip: 'Skip',
    savePlant: 'Save Plant',
    saveAndNext: 'Save & Next',
    completeLater: 'Complete Later',
    delete: 'Delete',
    deleting: 'Deleting...',
    undoChanges: 'Undo changes',
    // Crop
    cropInstructions: 'How to crop:',
    cropDesc: 'Click and drag anywhere on the image to draw a crop area. Drag the corner or edge handles to resize. Click "Done Cropping" when ready, or skip to use the full image.',
    // AI
    identifyingPlant: 'Identifying plant...',
    looksCorrect: 'Looks Correct',
    recrop: 'Re-crop',
    notRight: "That's not right",
    aiThinksThisIs: 'AI thinks this is:',
    wrongEnterCorrectName: 'Wrong? Enter the correct name:',
    pleaseEnterName: 'Please enter a name',
    aiAutoFill: 'Auto-fill with AI',
    aiAutoFillHint: 'Enter a plant name above, then click to auto-fill care details using AI.',
    // Add Plant titles
    addNewPlantTitle: 'Add New Plant',
    cropAndRotate: 'Crop & Rotate Photo',
    cropReopenFailed: 'Could not open photo to re-crop',
    convertingHeic: 'Converting HEIC…',
    cropAddPhotoBlurb: 'Frame the plant and rotate if needed so it lands right-side up in your gallery.',
    cropAddPhotoTip: 'Drag to crop; tap Rotate to fix orientation. If you don\'t draw a crop, the full rotated photo is saved.',
    aiIdentificationTitle: 'AI Identification',
    plantDetailsTitle: 'Plant Details',
    allDone: 'All Done!',
    // Summary
    processedPlants: 'Processed {count} plant(s):',
    // Duplicate
    duplicateFound: 'Duplicate Found',
    youAlreadyHave: 'You already have "{name}" in your library.',
    replaceExisting: 'Replace existing with this one',
    keepBoth: 'Keep both',
    discardThisOne: 'Discard this one, keep existing',
    // Batch & Toast messages
    photoXOfY: 'Photo {current} of {total}',
    plantXOfY: 'Plant {current} of {total}',
    clearUnfinished: 'Clear all',
    clearUnfinishedTitle: 'Clear unfinished entries?',
    clearUnfinishedConfirm: 'Remove all {n} unfinished {plantWord}? This can’t be undone.',
    clearedUnfinished: 'Removed {n} unfinished',
    skippedLabel: '(skipped)',
    returningToSkipped: 'Returning to skipped photos...',
    savedAsIncompleteNext: 'Saved as incomplete. Moving on...',
    savedAsIncompleteLater: 'Saved as incomplete. You can finish it later from the library.',
    keptExistingNext: 'Kept existing. Moving to next photo...',
    keptExistingPlant: 'Kept existing plant.',
    skippedWillReturn: 'Skipped — will come back to it later',
    removeThisPhoto: 'Remove this photo',
    removePhotoTitle: 'Remove this photo?',
    removePhotoDesc: "This photo will be discarded and won't be added. The other photos in this batch stay in the queue.",
    removePhotoConfirm: 'Remove photo',
    photoRemovedWithCount: 'Photo removed — {n} left',
    photoRemoved: 'Photo removed',
    photoRestored: 'Photo restored',
    resetZoom: 'Reset zoom',
    photoRetrying: 'Retrying… ({n})',
    photosReordered: 'Photo order updated',
    photosReorderFailed: 'Failed to reorder photos',
    retry: 'Retry',
    photoAddFailedRetry: "Couldn't add that photo. Please try again.",
    mergeFailedTitle: "Couldn't add the photo",
    mergeFailedDesc: 'Something went wrong adding this photo to "{name}". Your photo is safe — you can try again.',
    photoDupLibrary: 'This exact photo is already in your library as "{name}". You can add it anyway or remove it.',
    photoDupBatch: 'You already added this photo earlier in this batch. You can add it anyway or remove it.',
    anotherPlant: 'another plant',
    draftDiscarded: 'Draft discarded',
    draftRestored: 'Draft restored',
    addPlantExitBatchConfirm: 'You still have {n} photos to add. Leave and lose them?',
    batchExitTitle: 'Leave the batch?',
    batchExitBody: 'You still have {n} {plantWord} to add. Save them for later, or discard the batch?',
    batchExitSavedToast: 'Saved for later — resume from the library',
    keepEditing: 'Keep editing',
    saveForLater: 'Save for later',
    discardBatch: 'Discard',
    addPlantDraftBanner: 'You have {n} unfinished {plantWord} from last time.',
    addPlantDraftDiscardConfirm: 'Discard the unfinished batch? This cannot be undone.',
    plantSingular: 'plant',
    plantPlural: 'plants',
    resume: 'Resume',
    discard: 'Discard',
    aiDisclaimer: 'Care details are AI-generated (Google Gemini) and may not be accurate. Edit any field as needed — this is your personal inventory.',
    aiDisclaimerDetail: 'Care details are AI-generated using Google Gemini and may contain errors. Do your own research if scientific accuracy is important. You can edit any detail at any time.',
    // Care fields
    commonName: 'Common Name',
    scientificName: 'Scientific Name',
    watering: 'Watering',
    light: 'Light',
    humidity: 'Humidity',
    temperature: 'Temperature',
    toxicity: 'Toxicity',
    growthRate: 'Growth Rate',
    blooming: 'Blooming',
    bloomSeason: 'Bloom Season',
    bloomDuration: 'Bloom Duration',
    bloomsIndoors: 'Blooms Indoors?',
    bloomTips: 'Bloom Tips',
    toxicityNotes: 'Toxicity Notes',
    dormancyNotes: 'Dormancy Notes',
    bloomLasts: 'Lasts',
    bloomNotIndoors: 'Does not bloom indoors',
    bloomRarelyIndoors: 'Rarely blooms indoors',
    dormancy: 'Dormancy',
    dormantNow: 'Dormant now',
    needsDormancy: 'Needs dormancy',
    dormancyBannerOne: '1 plant is in its dormancy window this month.',
    dormancyBannerMany: '{count} plants are in their dormancy window this month.',
    dormancyBannerAction: 'Show them',
    backfillPromptOne: '1 plant is missing some care details.',
    backfillPromptMany: '{count} plants are missing some care details.',
    backfillPromptAction: 'Fill them in →',
    iconLegend: 'Icon legend',
    show: 'Show',
    hide: 'Hide',
    legendCareSection: 'Care details',
    legendLibrarySection: 'Library controls',
    legendFamily: 'Botanical family (e.g. Araceae, Cactaceae).',
    legendPlantType: 'Growth form: succulent, vine, herbaceous perennial, etc.',
    legendWatering: 'How often and how much to water this plant.',
    legendLight: 'Preferred light level, from low to full sun.',
    legendHumidity: 'Humidity range the plant is happy in.',
    legendTemperature: 'Ideal temperature range in °F and °C.',
    legendToxicity: 'Whether it is toxic to pets, humans, or reptiles.',
    legendEnvironment: 'Standard household, terrarium preferred, or terrarium required.',
    legendGrowthRate: 'Slow, moderate, or fast grower.',
    legendDormancy: 'Fall/winter rest period — expect leaf drop or slower growth.',
    aiCareNote: 'AI note',
    legendAiNote: 'AI-generated care information — verify against trusted sources.',
    legendIncomplete: 'Complete later',
    legendIncompleteHint: 'Plant is saved but missing photos or care details.',
    legendPhoto: 'Add / replace photo',
    legendPhotoHint: 'Attach up to 5 photos per plant.',
    legendArchive: 'Archive',
    legendArchiveHint: 'Move a plant off the main library without deleting it.',
    legendTerrarium: 'Terrarium filter',
    legendTerrariumHint: 'Show only plants that need or prefer a terrarium.',
    legendDormant: 'Dormant filter',
    legendDormantHint: 'Show only plants currently in their dormancy window.',
    legendSearchPlaceholder: 'Search icons…',
    legendNoResults: 'No icons match your search.',
    backfillLastRun: 'Last refreshed',
    backfillLastUpdated: 'updated',
    resetMarkersLink: 'Re-scan skipped plants',
    resetMarkersLinkDormancy: 'Re-scan dormancy',
    resetMarkersLinkAll: 'Re-scan everything',
    resetMarkersConfirm: 'This will clear every backfill "checked" mark on every plant so the next scan can re-ask the AI about them. Continue?',
    resetMarkersDormancyConfirm: 'This will clear the dormancy "checked" mark on every plant so the next scan can re-ask the AI. Continue?',
    repairTextLink: 'Repair mangled text',
    repairTextConfirm: 'Repair any corrupt dormancy / toxicity text on your plants? Existing values are only re-spaced, never rewritten by AI. Safe to run any time.',
    'careLog.title': 'Care Log',
    'careLog.empty': 'No care events yet — tap a button above to log the first one.',
    'careLog.undo': 'Undo',
    'careLog.addFailed': 'Failed to log — try again.',
    'careLog.deleteFailed': 'Failed to undo — try again.',
    'careLog.moreEntries': '{count} older entries',
    'careLog.action.watered': 'Water',
    'careLog.action.fertilized': 'Fertilize',
    'careLog.action.repotted': 'Repot',
    'careLog.action.pruned': 'Prune',
    'careLog.actionPast.watered': 'Watered',
    'careLog.actionPast.fertilized': 'Fertilized',
    'careLog.actionPast.repotted': 'Repotted',
    'careLog.actionPast.pruned': 'Pruned',
    'careLog.actionDone.watered': 'Logged: watered',
    'careLog.actionDone.fertilized': 'Logged: fertilized',
    'careLog.actionDone.repotted': 'Logged: repotted',
    'careLog.actionDone.pruned': 'Logged: pruned',
    'careLog.growthTimeline': 'Growth timeline',
    'careLog.attachPhoto': 'Attach photo',
    'careLog.photoAdded': 'Photo added to entry',
    'careLog.photoFailed': 'Failed to attach photo',
    'careLog.editNote': 'Edit note',
    'careLog.notePlaceholder': 'e.g. first new leaf!',
    'careLog.noteEditFailed': 'Failed to save note — try again.',
    'careLog.setAsCover': 'Set as cover',
    'careLog.setAsCoverDone': 'Set as cover photo',
    'careLog.setAsCoverDoneShort': 'Cover set',
    'careLog.setAsCoverFailed': 'Failed to set as cover',
    'careLog.compare': 'Compare',
    'careLog.stopCompare': 'Stop compare',
    'careLog.comparePickPrompt': 'Pick a photo to compare with:',
    'careLog.comparePickAria': 'Compare with {action} photo from {date}',
    'careLog.exportTimeline': 'Export PDF',
    'careLog.exporting': 'Preparing timeline PDF…',
    'careLog.exportDone': 'Timeline exported',
    'careLog.exportFailed': 'Failed to export timeline',
    'careLog.share': 'Share',
    'careLog.shareTimeline': 'Share timeline',
    'careLog.sharing': 'Preparing timeline image…',
    'careLog.shareDone': 'Shared timeline',
    'careLog.shareFailed': 'Failed to share timeline',
    'careLog.downloaded': 'Timeline image downloaded',
    'careLog.oldestFirst': 'Oldest first',
    'careLog.newestFirst': 'Newest first',
    'careLog.sortOldestFirst': 'Sort oldest first',
    'careLog.sortNewestFirst': 'Sort newest first',
    'fillMissingAiTitle': 'Fill in any missing AI-provided information',
    'fillMissingAiButton': 'Check what needs filling',
    'fillMissingAiConfirm': 'Fill them',
    'fillMissingAiRunning': 'Filling in details… this may take several minutes',
    'fillMissingAiChecking': 'Checking your library…',
    'fillMissingAiInfo': "Asks the AI to fill in any missing care details (watering, light, family, environment, etc.). Existing values are never overwritten. Runs in small chunks so it works cleanly on large libraries — safe to stop and resume any time.",
    'fillFieldsAll': 'Fill every missing field',
    'fillFieldsCount': 'Fill only: {n} field(s)',
    'fillPickAtLeastOne': 'Pick at least one field to fill.',
    'choose': 'Choose ▾',
    'clearAll': 'Clear',
    'advancedShow': 'Advanced options',
    'advancedHide': 'Hide advanced',
    'advancedIntro': 'Force a re-scan of details the AI already answered. Costs extra AI calls.',
    'careField.watering': 'Watering',
    'careField.light': 'Light',
    'careField.humidity': 'Humidity',
    'careField.temperature': 'Temperature',
    'careField.toxicity': 'Toxicity',
    'careField.environment': 'Environment',
    'careField.growthRate': 'Growth rate',
    'careField.familyType': 'Family & type',
    'careField.dormancy': 'Dormancy',
    'careField.blooming': 'Blooming',
    backfillRunningTitle: 'Backfill in progress',
    backfillRunningBody: 'The AI is still filling missing care details. Would you like it to keep running in the background, or stop at the current point?',
    backfillContinueBackground: 'Continue in background',
    backfillStopNow: 'Stop now',
    backfillBgDoneTitle: 'Backfill complete — {count} plants updated.',
    backfillBgDoneHint: 'Reload to see the fresh care details.',
    reloadNow: 'Reload',
    'backfillEstimator': 'About {sec}s per plant × {count} plants ≈ {time}',
    'backfillResumeHeader': 'Resume your last fill',
    'backfillResumeDetail': '{filled} filled, {remaining} still to go from {ago}.',
    'backfillResumeContinue': 'Continue',
    'dismiss': 'Dismiss',
    'autoBackfillOnAdd': 'Auto-fill missing details when adding a new plant',

    environment: 'Environment',
    terrariumOnly: 'Terrarium plants',
    showAllPlants: 'Show all plants',
    readMore: 'Read more',
    showLess: 'Show less',
    exportPlants: 'Export plants',
    sharePlants: 'Share',
    preloadPhotos: 'Preload all photos',
    photosOnDevice: 'Your photos are already on this device',
    noPhotosToPreload: 'No photos to preload',
    preloadingPhotos: 'Preloading photos…',
    photosReady: 'Photos ready',
    couldNotLoad: 'unavailable',
    photoReadFailed: "Couldn't read that photo — please pick it again",
    chooseDifferentPhoto: 'Choose a different photo',
    skipThisPhoto: 'Skip this one',
    exportCSV: 'Download CSV',
    exportPDF: 'Download PDF',
    downloadLibrary: 'Download library',
    downloadFormatLabel: 'Download format',
    downloadLibraryDesc: 'CSV is best for reimporting into spreadsheets or other tools. PDF gives a formatted printable copy with proper support for non-Latin plant names.',
    download: 'Download',
    downloading: 'Downloading…',
    shareLibrary: 'Share as image',
    copyInviteLink: 'Copy invite link',
    previewInvite: 'Preview invite page',
    showQrCode: 'Show QR code',
    qrScanPlant: 'Scan to open this plant',
    dateAdded: 'Date Added',
    addedOn: 'Added',
    family: 'Family',
    plantType: 'Type',
    careDetails: 'Care Details',
    // Sources
    learnMore: 'Learn more from reputable sources',
    tapToEnlarge: 'Tap to enlarge',
    scrollForCareDetails: 'Scroll for care details',
    backfillChipProgress: 'Filling {filled}/{total}…',
    backfillChipTitle: 'Backfill running — tap to open Settings',
    recentSearchesLabel: 'Recent searches',
    recentSearchesClear: 'Clear',
    remove: 'Remove',
    themeLabel: 'Appearance',
    themeLight: 'Light',
    themeDark: 'Dark',
    themeAuto: 'Auto',
    themeHelp: 'Choose a light or dark palette. Auto follows your system setting and updates live when you change it.',
    familyTipLead: 'Your {family} collection ({count})',
    filter: 'Filter',
    filterBy: 'Filter by',
    clearFilters: 'Clear all filters',
    remove: 'Remove',
    sortGroupBy: 'Sort / Group by',
    sortNameAsc: 'Name (A → Z)',
    sortNameDesc: 'Name (Z → A)',
    sortDateAdded: 'Date Added (Newest)',
    addedOn: 'Added',
    thenBy: 'Then by',
    thenByPlaceholder: 'Then by…',
    thenByNone: 'None',
    watchOnboardingTour: 'Watch onboarding tour',
    watch: 'Watch',
    skip: 'Skip',
    back: 'Back',
    next: 'Next',
    done: 'Got it',
    tourStep1Title: 'Add your first plant',
    tourStep1Body: 'Tap the orange + button in the bottom-right corner to snap a photo or pick one from your gallery. The AI will identify the plant and fill in care details in seconds.',
    tourStep2Title: 'AI does the heavy lifting',
    tourStep2Body: 'The moment you add a plant, the AI identifies it and starts filling in watering, light, humidity, dormancy and more — automatically. You can keep browsing while it works in the background, even if your phone locks.',
    tourStep3Title: 'Share your collection',
    tourStep3Body: 'Tap the Share icon in the header to send a friend a "Grow-along" invite link. They\u2019ll see your library in a read-only view — no account needed. Great for showing off your greens.',
    tourStep4Title: 'Decode the care icons',
    tourStep4Body: 'Every plant\u2019s detail view has a small ? Icon Legend button next to "Care Details" — tap it to see what every symbol means: watering, light, humidity, dormancy, and more. Handy when you\u2019re just getting started.',
    tourChapterCapture: 'Capture',
    tourChapterNurture: 'Nurture',
    tourChapterShare: 'Share & Organize',
    tourChapterOf: 'Chapter {n} of 3',
    tourCaptureBatchTitle: 'Add many at once',
    tourCaptureBatchBody: 'In a hurry? Pick several photos in one go — each becomes its own plant. You can also add multiple photos to a single plant, drag to reorder them and choose the cover shot. Re-adding a plant you already have? The app offers to merge the new photo in instead of making a duplicate.',
    tourNurtureLogTitle: 'Log care & watch it grow',
    tourNurtureLogBody: 'Open any plant to log waterings, feedings and notes on a running care timeline, and track progress with before/after growth photos. The app even follows each plant\u2019s dormancy so seasonal care stays on point.',
    tourNurtureOrganizeTitle: 'Find & organize anything',
    tourNurtureOrganizeBody: 'Search by common or botanical name, then sort and group your library by family, type or your own order. Archive plants you no longer own without losing any of their history.',
    tourShareBodyDrive: 'Tap Share to send a friend a read-only "Grow-along" link — no account needed to view. Add a warm welcome note, or show a QR code so anyone nearby can scan and browse your greens.',
    tourShareBodyLocal: 'Tap Share to create a read-only "Grow-along" link or QR code of your collection — no account needed for them to view. Add a warm welcome note to greet your visitors.',
    tourExportTitle: 'Back up & export',
    tourExportBodyDrive: 'Your library and photos sync safely to your own Google Drive automatically, so nothing is ever lost. Need a copy? Export a polished PDF care sheet or a CSV of your whole collection anytime.',
    tourExportBodyLocal: 'Everything lives privately on this device. Export a polished PDF care sheet or a CSV backup whenever you like — perfect for safekeeping or moving your collection to another device.',
    tourPersonalizeTitle: 'Make it yours',
    tourPersonalizeBodyDrive: 'Switch to dark mode, choose your language, and install the app to your home screen like a native app. It works offline too — any changes you make sync automatically the moment you\u2019re back online.',
    tourPersonalizeBodyLocal: 'Switch to dark mode, choose your language, and install the app to your home screen like a native app. It works fully offline — ideal for a greenhouse or balcony with no signal.',
    tourAddFirstPlant: 'Add your first plant',
    tourReadFullGuide: 'Read the full guide',
    translating: 'Translating...',
    retryTranslation: 'Retry translation',
    // Settings
    settings: 'Settings',
    geminiApiKey: 'Google Gemini API Key',
    photoQuality: 'Photo Quality',
    fontSize: 'Font Size',
    language: 'Language',
    languageDesc: 'Sets the display language for the app. Default is English (US).',
    saveSettings: 'Save Settings',
    // Footer & Nav
    backToTop: 'Back to top',
    readingProgress: 'Reading progress',
    linkCopied: 'Link copied',
    copyLinkToSection: 'Copy link to this section',
    copyPlantLink: 'Copy share link',
    copyLinkFailed: 'Could not copy link',
    qrCreateFailed: 'Could not create QR code',
    withPhotos: 'With photos',
    noPhotos: 'No photos',
    // Actions
    export: 'Export CSV',
    signOut: 'Sign out',
    // Navigation & Pagination
    back: 'Back',
    previous: 'Previous',
    next: 'Next',
    page: 'Page',
    perPage: 'Per page',
    // View modes
    grouped: 'Grouped',
    by: 'by',
    // Library sections
    needsAttention: 'Needs Attention',
    toComplete: 'to complete',
    found: 'Found',
    // Backfill
    updateAll: 'Update All',
    updating: 'Updating...',
    dismiss: 'Dismiss',
    missingFamilyType: 'missing Family & Type info.',
    // Local mode
    deviceOnlyMode: 'Device-only mode',
    plantsUsed: 'plants used',
    signInGoogleSync: 'Sign in with Google to sync',
    // Drive connection
    connectGoogleDrive: 'Connect Google Drive',
    connectDriveDesc: 'Your plants and photos will be stored securely in your Google Drive. This keeps your data private and synced across devices.',
    // Dialogs
    deletePlant: 'Delete Plant',
    deleteConfirmLocal: 'Are you sure you want to delete this plant? This will permanently remove it from your device. This action cannot be undone.',
    deleteConfirmDrive: 'Are you sure you want to delete this plant? This will permanently remove it and its photo from your Google Drive. This action cannot be undone.',
    exitLocalMode: 'Exit Local Mode',
    logoutTitle: 'Logout',
    logoutConfirmLocal: 'Your plants are saved on this device and will still be here when you return. You can sign in with Google later to sync your data to the cloud.',
    logoutConfirmDrive: "Are you sure you want to logout? You'll need to sign in again to access your plants.",
    exit: 'Exit',
    // Empty states
    tryDifferentSearch: 'Try a different search term',
    noPlantsInstruction: 'To see your plant library, add your first plant using the orange button in the bottom-right corner.',
    addNewPlant: 'Add a new plant',
    normalCards: 'Normal cards',
    compactCards: 'Compact cards',
    listViewLabel: 'List view',
    unnamedPlant: 'Unnamed Plant',
    skipToLibrary: 'Skip to plant library',
    saving: 'Saving...',
    viewDetails: 'View details',
    deleteThisPlant: 'Delete this plant?',
    // Login page
    loginSubtitle1: 'Your personal houseplant care companion.',
    loginSubtitle2: 'Track, identify, and nurture your green friends.',
    getStarted: 'Get Started',
    loginSignInDesc: 'Sign in with Google to sync your plants across devices',
    continueWithGoogle: 'Continue with Google',
    or: 'or',
    idRatherNot: "I'd rather not",
    onDeviceStorage: 'On-device storage (no login)',
    acknowledgeEach: 'Please acknowledge each item before continuing:',
    continueToLocalMode: 'Continue to local mode',
    acknowledgeAll: 'Acknowledge all',
    aboutAndInstructions: 'About & Instructions',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    aiIdentify: 'AI Identify',
    cloudSync: 'Cloud Sync',
    careTips: 'Care Tips',
    aiIdentifyDesc: 'Snap a photo and our AI will identify your plant instantly',
    cloudSyncDesc: 'Your plant library is safely stored in your Google Drive',
    careTipsDesc: 'Get personalized watering, light, and humidity care details',
    localWarning1: 'Your plant data will be stored <strong>only on this device</strong>, in this browser.',
    localWarning2: '<strong>Clearing your browser data will permanently delete all your plants.</strong>',
    localWarning3: 'You are limited to <strong>100 plants</strong> (or fewer if your device has low storage).',
    localWarning4: 'Your data will <strong>not sync</strong> across devices.',
    localWarning5: 'You can sign in with Google later to move your data to the cloud.',
    // Bulk Edit
    bulkEdit: 'Bulk Edit',
    selected: 'selected',
    selectAll: 'Select all',
    deselectAll: 'Deselect all',
    chooseField: 'Choose field',
    bulkEditBarLabel: 'Bulk edit',
    chooseValue: 'Choose value',
    enterValue: 'Enter value...',
    applying: 'Applying...',
    applyToSelected: 'Apply',
    exitBulkEdit: 'Exit bulk edit',
    bulkEditConfirmTitle: 'Confirm Bulk Edit',
    bulkEditConfirmDesc: 'Update {field} to "{value}" for {count} selected plant(s)?',
    applyChanges: 'Apply Changes',
    bulkUpdateSuccess: 'Updated {count} plant(s) successfully',
    bulkUpdateFailed: 'Bulk update failed',
    deleteSelected: 'Delete Selected',
    bulkDeleteConfirmTitle: 'Confirm Bulk Delete',
    bulkDeleteConfirmDesc: 'Permanently delete {count} selected plant(s)? This cannot be undone.',
    bulkDeleteSuccess: 'Deleted {count} plant(s) successfully',
    bulkDeleteFailed: 'Bulk delete failed',
  },
  es: {
    appName: 'Mi Inventario Personal de Plantas',
    appTagline: 'Tu compañero personal para el cuidado de plantas.',
    appTagline2: 'Rastrea, identifica y cuida a tus amigos verdes.',
    signInPrompt: 'Inicia sesión con Google para sincronizar tus plantas',
    localModeButton: 'Prefiero no hacerlo',
    localWarningTitle: 'Antes de continuar sin cuenta:',
    continueLocalMode: 'Continuar en modo local',
    cancelLocalMode: 'Cancelar',
    myPlants: 'Mis Plantas',
    searchPlants: 'Buscar plantas...',
    noPlants: 'Aún no hay plantas',
    noPlantsDesc: '¡Toca el botón + para agregar tu primera planta!',
    noResults: 'Ninguna planta coincide con tu búsqueda',
    incomplete: 'Incompleto',
    showing: 'Mostrando',
    of: 'de',
    plants: 'plantas',
    plant: 'planta',
    addPlant: 'Agregar Planta',
    editPlant: 'Editar Planta',
    edit: 'Editar',
    addPhoto: 'Agregar Foto',
    replacePhoto: 'Reemplazar Foto',
    photoUpdated: 'Foto actualizada',
    photoAdded: 'Foto añadida',
    photoReplaced: 'Foto reemplazada',
    photoUpdateFailed: 'Error al actualizar la foto',
    batchAdd: 'Agregar en lote',
    fromCamera: 'Desde Cámara',
    mergeIntoAnother: "Fusionar con otra planta",
    mergeDialogTitle: "Fusionar estas dos plantas",
    mergeDialogBlurb: "La CONSERVADA se queda en tu biblioteca y absorbe todo de la otra planta. Elige qué valor gana en cada campo. Las fotos se combinan hasta un máximo de 5.",
    mergeDialogBlurbV2: "Verifica que los nombres común y científico coincidan, elige qué fotos conservar y selecciona una portada. La otra planta será absorbida.",
    mergeKeeper: "Conservada (se queda)",
    mergeAbsorbedTitle: "Absorbida (eliminada)",
    mergeAbsorbed: "Absorbida",
    mergeKeepThis: "Conservada",
    mergePhotos: "foto(s)",
    mergeConfirm: "Fusionar plantas",
    mergeInProgress: "Fusionando…",
    mergeFailed: "Fusión fallida",
    mergeSuccess: "Plantas fusionadas.",
    mergeSuccessWithDrop: "Fusionadas. {n} foto(s) extra descartada(s) (máx. 5).",
    mergeSameError: "No puedes fusionar una planta consigo misma.",
    mergeDiffHeader: "{n} campo(s) de cuidados difieren — elige uno",
    mergeNoDiff: "Las dos plantas tienen la misma información de cuidados — nada que reconciliar.",
    mergePhotoWarning: "⚠ Se descartarán {n} foto(s) extra (máx. 5 por planta).",
    mergeEmpty: "—",
    mergeAction: "Fusionar",
    mergePickerTitle: "Fusionar con otra planta",
    mergePickerBlurb: "Elige la planta que debe quedarse (la Conservada). {name} se fusionará con ella.",
    mergePickerSearch: "Buscar por nombre…",
    mergePickerSuggested: "Duplicados probables",
    mergePickerEmpty: "No hay otras plantas que coincidan.",
    mergeSelected: "Fusionar seleccionadas",
    mergeRequiresTwo: "Selecciona exactamente 2 plantas para fusionar",
    mergePlantsNotFound: "Plantas seleccionadas no encontradas",
    duplicateBadge: "¿Duplicada?",
    duplicateBannerBody: "Dos entradas comparten el nombre «{name}». ¿Fusionarlas?",
    fromGallery: 'Desde Galería',
    enterManually: 'Ingresar manualmente sin foto',
    doneCropping: 'Listo',
    rotate: 'Rotar',
    cancel: 'Cancelar',
    skip: 'Omitir',
    savePlant: 'Guardar Planta',
    saveAndNext: 'Guardar y Siguiente',
    completeLater: 'Completar Después',
    delete: 'Eliminar',
    deleting: 'Eliminando...',
    undoChanges: 'Deshacer cambios',
    cropInstructions: 'Cómo recortar:',
    cropDesc: 'Haz clic y arrastra en cualquier lugar de la imagen para dibujar un área de recorte. Arrastra las esquinas o bordes para redimensionar. Haz clic en "Listo" cuando estés listo.',
    identifyingPlant: 'Identificando planta...',
    looksCorrect: 'Es Correcto',
    recrop: 'Recortar',
    notRight: 'No es correcto',
    aiThinksThisIs: 'La IA cree que es:',
    wrongEnterCorrectName: '¿Incorrecto? Ingresa el nombre correcto:',
    pleaseEnterName: 'Por favor ingresa un nombre',
    aiAutoFill: 'Autocompletar con IA',
    aiAutoFillHint: 'Ingresa un nombre arriba, luego haz clic para autocompletar los detalles de cuidado con IA.',
    addNewPlantTitle: 'Agregar Nueva Planta',
    cropAndRotate: 'Recortar y Rotar Foto',
    aiIdentificationTitle: 'Identificación IA',
    plantDetailsTitle: 'Detalles de la Planta',
    allDone: '¡Todo Listo!',
    processedPlants: '{count} planta(s) procesada(s):',
    duplicateFound: 'Duplicado Encontrado',
    youAlreadyHave: 'Ya tienes "{name}" en tu biblioteca.',
    replaceExisting: 'Reemplazar existente con esta',
    keepBoth: 'Mantener ambas',
    discardThisOne: 'Descartar esta, mantener existente',
    photoXOfY: 'Foto {current} de {total}',
    skippedLabel: '(omitida)',
    returningToSkipped: 'Regresando a las fotos omitidas...',
    savedAsIncompleteNext: 'Guardada como incompleta. Continuando...',
    savedAsIncompleteLater: 'Guardada como incompleta. Puedes terminarla más tarde desde la biblioteca.',
    keptExistingNext: 'Se mantuvo la existente. Pasando a la siguiente foto...',
    keptExistingPlant: 'Se mantuvo la planta existente.',
    skippedWillReturn: 'Omitida — volveremos a ella más tarde',
    removeThisPhoto: 'Eliminar esta foto',
    removePhotoTitle: '¿Eliminar esta foto?',
    removePhotoDesc: 'Esta foto se descartará y no se añadirá. Las demás fotos de este lote permanecen en la cola.',
    removePhotoConfirm: 'Eliminar foto',
    photoRemovedWithCount: 'Foto eliminada — quedan {n}',
    photoRemoved: 'Foto eliminada',
    photoRestored: 'Foto restaurada',
    photoDupLibrary: 'Esta misma foto ya está en tu biblioteca como «{name}». Puedes añadirla de todos modos o eliminarla.',
    photoDupBatch: 'Ya añadiste esta foto antes en este lote. Puedes añadirla de todos modos o eliminarla.',
    anotherPlant: 'otra planta',
    draftDiscarded: 'Borrador descartado',
    draftRestored: 'Borrador restaurado',
    aiDisclaimer: 'Los detalles de cuidado son generados por IA (Google Gemini) y pueden no ser precisos. Edita cualquier campo según sea necesario.',
    aiDisclaimerDetail: 'Los detalles de cuidado son generados por IA usando Google Gemini y pueden contener errores. Investiga por tu cuenta si la precisión científica es importante.',
    commonName: 'Nombre Común',
    scientificName: 'Nombre Científico',
    watering: 'Riego',
    light: 'Luz',
    humidity: 'Humedad',
    temperature: 'Temperatura',
    toxicity: 'Toxicidad',
    growthRate: 'Tasa de Crecimiento',
    blooming: 'Floración',
    bloomSeason: 'Temporada de floración',
    bloomDuration: 'Duración de la floración',
    bloomsIndoors: '¿Florece en interior?',
    bloomTips: 'Consejos de floración',
    toxicityNotes: 'Notas de toxicidad',
    dormancyNotes: 'Notas de dormancia',
    bloomLasts: 'Dura',
    bloomNotIndoors: 'No florece en interior',
    bloomRarelyIndoors: 'Rara vez florece en interior',
    dormancy: 'Dormancia',
    dormantNow: 'En dormancia',
    needsDormancy: 'Necesita dormancia',
    dormancyBannerOne: '1 planta está en su periodo de dormancia este mes.',
    dormancyBannerMany: '{count} plantas están en su periodo de dormancia este mes.',
    dormancyBannerAction: 'Mostrarlas',
    backfillPromptOne: 'A 1 planta le faltan detalles de cuidado.',
    backfillPromptMany: 'A {count} plantas les faltan detalles de cuidado.',
    backfillPromptAction: 'Rellenarlos →',
    iconLegend: 'Leyenda de iconos',
    show: 'Mostrar',
    hide: 'Ocultar',
    legendCareSection: 'Detalles de cuidados',
    legendLibrarySection: 'Controles de la biblioteca',
    legendFamily: 'Familia botánica (por ejemplo, Araceae, Cactaceae).',
    legendPlantType: 'Forma de crecimiento: suculenta, enredadera, perenne herbácea, etc.',
    legendWatering: 'Con qué frecuencia y cuánto regar esta planta.',
    legendLight: 'Nivel de luz preferido, de poca luz a sol pleno.',
    legendHumidity: 'Rango de humedad en el que la planta se encuentra a gusto.',
    legendTemperature: 'Rango de temperatura ideal en °F y °C.',
    legendToxicity: 'Si es tóxica para mascotas, humanos o reptiles.',
    legendEnvironment: 'Hogar estándar, terrario preferido o terrario obligatorio.',
    legendGrowthRate: 'Crecimiento lento, moderado o rápido.',
    legendDormancy: 'Periodo de descanso otoño/invierno — es normal la caída de hojas o menor crecimiento.',
    aiCareNote: 'Nota de IA',
    legendAiNote: 'Información generada por IA — verifica en fuentes de confianza.',
    legendIncomplete: 'Completar más tarde',
    legendIncompleteHint: 'Planta guardada pero faltan fotos o detalles de cuidado.',
    legendPhoto: 'Añadir / reemplazar foto',
    legendPhotoHint: 'Añade hasta 5 fotos por planta.',
    legendArchive: 'Archivar',
    legendArchiveHint: 'Mueve una planta fuera de la biblioteca principal sin borrarla.',
    legendTerrarium: 'Filtro de terrario',
    legendTerrariumHint: 'Muestra solo plantas que necesitan o prefieren un terrario.',
    legendDormant: 'Filtro de dormancia',
    legendDormantHint: 'Muestra solo las plantas actualmente en su periodo de dormancia.',
    legendSearchPlaceholder: 'Buscar iconos…',
    legendNoResults: 'Ningún icono coincide con tu búsqueda.',
    environment: 'Entorno',
    terrariumOnly: 'Plantas de terrario',
    showAllPlants: 'Mostrar todas las plantas',
    readMore: 'Leer más',
    showLess: 'Mostrar menos',
    lastSyncedLabel: 'Última sincronización',
    refreshNow: 'Actualizar ahora',
    refreshSyncing: 'Actualizando\u2026',
    refreshOffline: 'Sin conexión: vuelve a conectarte para actualizar.',
    offlineCacheTitle: 'Caché sin conexión',
    offlineCacheBlurb: 'Una copia de solo lectura de tu biblioteca guardada en este dispositivo para poder consultarla sin conexión.',
    offlineCacheStats: '{count} {plantWord} \u00b7 {size} \u00b7 guardada {when}',
    offlineCacheClear: 'Borrar caché sin conexión',
    offlineCacheCleared: 'Caché sin conexión borrada',
    offlineCacheClearFailed: 'No se pudo borrar la caché sin conexión',
    pendingSyncPill: '{n} cambios pendientes de sincronizar',
    pendingSyncPillOne: '1 cambio pendiente de sincronizar',
    pendingSyncTitle: 'Cambios en espera de sincronización',
    pendingSyncBlurbOnline: 'Estos cambios están guardados en este dispositivo y se sincronizarán automáticamente.',
    pendingSyncBlurbOffline: 'Estás sin conexión. Se sincronizarán en cuanto vuelvas a conectarte.',
    pendingSyncRetry: 'Reintentar ahora',
    pendingSyncSyncing: 'Sincronizando\u2026',
    pendingSyncDiscard: 'Descartar este cambio',
    pendingSyncDiscardAll: 'Descartar todo',
    pendingSyncDiscardAllConfirmTitle: '¿Descartar todos los cambios pendientes?',
    pendingSyncDiscardAllConfirmBody: 'Esto elimina {n} cambios en espera de sincronización y los revierte en este dispositivo.',
    pendingSyncDiscardAllConfirmBodyOne: 'Esto elimina 1 cambio en espera de sincronización y lo revierte en este dispositivo.',
    pendingSyncDiscardAllToast: 'Se descartaron todos los cambios pendientes',
    aboutTocTitle: 'En esta página',
    pendingSyncViewDetails: 'Detalles',
    allChangesSynced: 'Todos los cambios sincronizados',
    addOfflineNotice: 'Estás sin conexión: las plantas nuevas requieren conexión. Editar, archivar y eliminar funcionan y se sincronizan al volver.',
    pendingWaitingFor: 'esperando {time}',
    syncProgress: '{done} de {total} sincronizados',
    syncHistoryTitle: 'Actividad de sincronización reciente',
    syncHistoryClear: 'Borrar',
    syncStatusSynced: 'Sincronizado',
    syncStatusConflict: 'Conflicto',
    syncStatusGaveup: 'Fallido',
    syncStatusDiscarded: 'Descartado',
    discardUndo: 'Deshacer',
    changeDiscarded: 'Cambio descartado',
    syncSyncedOne: '1 cambio sincronizado',
    syncSyncedMany: '{n} cambios sincronizados',
    syncConflictOne: 'No se pudo sincronizar "{name}": se cambió o eliminó en otro dispositivo.',
    syncConflictMany: '{n} cambios no se pudieron sincronizar: esas plantas se cambiaron o eliminaron en otro dispositivo.',
    syncGaveupOne: 'Se abandonó la sincronización de "{name}" tras varios intentos: vuelve a hacerlo.',
    syncGaveupMany: '{n} cambios no se pudieron guardar tras varios intentos y se descartaron.',
    syncRetryOne: '1 cambio no se pudo sincronizar: se reintentará',
    syncRetryMany: '{n} cambios no se pudieron sincronizar: se reintentarán',
    offlineHelpTitle: 'Sin conexión y sincronización',
    offlineHelpBody: 'Sin conexión puedes explorar y editar, archivar o eliminar plantas: esos cambios se ponen en cola y se sincronizan al reconectarte. Añadir una planta nueva requiere conexión.',
    offlineHelpLearnMore: 'Más información',
    aboutSharingTitle: 'Compartir tus plantas',
    aboutSharingBody: 'Comparte una sola planta como imagen enriquecida, o toda tu biblioteca como PDF: vista general (fotos + nombres), con todos los detalles (una página por planta) o solo nombres. Cada PDF incluye un código QR escaneable, un enlace y tu nota de bienvenida. Quien la reciba abre una vista \u201cgrow-along\u201d de solo lectura; nada de tu biblioteca cambia y no pueden editarla.',
    savedOfflineToast: 'Guardado sin conexión: se sincronizará al reconectarte',
    offlineWriteBlocked: 'Estás sin conexión: vuelve a conectarte para guardar los cambios.',
    done: 'Entendido',
    pendingOpEdit: 'Editar \u201c{name}\u201d',
    pendingOpArchive: 'Archivar \u201c{name}\u201d',
    pendingOpDelete: 'Eliminar \u201c{name}\u201d',
    pendingOpBulkUpdate: 'Actualizar {count} {plantWord}',
    pendingOpBulkDelete: 'Eliminar {count} {plantWord}',
    dateAdded: 'Fecha de Adición',
    addedOn: 'Añadido',
    family: 'Familia',
    plantType: 'Tipo',
    careDetails: 'Detalles de Cuidado',
    learnMore: 'Más información de fuentes confiables',
    tapToEnlarge: 'Toca para ampliar',
    translating: 'Traduciendo...',
    retryTranslation: 'Reintentar traducción',
    settings: 'Configuración',
    geminiApiKey: 'Clave API de Google Gemini',
    photoQuality: 'Calidad de Foto',
    fontSize: 'Tamaño de Fuente',
    language: 'Idioma',
    languageDesc: 'Establece el idioma de la aplicación. Por defecto es inglés (EE.UU.).',
    saveSettings: 'Guardar Configuración',
    downloadLibrary: 'Descargar biblioteca',
    downloadLibraryDesc: 'CSV es ideal para reimportar a hojas de cálculo u otras herramientas. PDF ofrece una copia imprimible con formato y compatibilidad con nombres de plantas en caracteres no latinos.',
    download: 'Descargar',
    downloading: 'Descargando…',
    sharePlants: 'Compartir',
    preloadPhotos: 'Precargar todas las fotos',
    photosOnDevice: 'Tus fotos ya están en este dispositivo',
    noPhotosToPreload: 'No hay fotos para precargar',
    preloadingPhotos: 'Precargando fotos…',
    photosReady: 'Fotos listas',
    couldNotLoad: 'no disponibles',
    photoReadFailed: 'No se pudo leer esa foto: selecciónala de nuevo',
    backToTop: 'Volver arriba',
    readingProgress: 'Progreso de lectura',
    linkCopied: 'Enlace copiado',
    copyLinkToSection: 'Copiar enlace a esta sección',
    copyPlantLink: 'Copiar enlace para compartir',
    copyLinkFailed: 'No se pudo copiar el enlace',
    qrCreateFailed: 'No se pudo crear el código QR',
    sortNameAsc: 'Nombre (A → Z)',
    sortNameDesc: 'Nombre (Z → A)',
    thenBy: 'Luego por',
    thenByPlaceholder: 'Luego por…',
    withPhotos: 'Con fotos',
    noPhotos: 'Sin fotos',
    export: 'Exportar CSV',
    signOut: 'Cerrar sesión',
    back: 'Volver',
    previous: 'Anterior',
    next: 'Siguiente',
    page: 'Página',
    perPage: 'Por página',
    grouped: 'Agrupado',
    by: 'por',
    needsAttention: 'Necesita Atención',
    toComplete: 'por completar',
    found: 'Encontrados',
    updateAll: 'Actualizar Todo',
    updating: 'Actualizando...',
    dismiss: 'Descartar',
    missingFamilyType: 'sin información de Familia y Tipo.',
    deviceOnlyMode: 'Modo solo dispositivo',
    plantsUsed: 'plantas usadas',
    signInGoogleSync: 'Inicia sesión con Google para sincronizar',
    connectGoogleDrive: 'Conectar Google Drive',
    connectDriveDesc: 'Tus plantas y fotos se almacenarán de forma segura en tu Google Drive. Esto mantiene tus datos privados y sincronizados entre dispositivos.',
    deletePlant: 'Eliminar Planta',
    deleteConfirmLocal: '¿Estás seguro de que quieres eliminar esta planta? Se eliminará permanentemente de tu dispositivo. Esta acción no se puede deshacer.',
    deleteConfirmDrive: '¿Estás seguro de que quieres eliminar esta planta? Se eliminará permanentemente junto con su foto de tu Google Drive. Esta acción no se puede deshacer.',
    exitLocalMode: 'Salir del Modo Local',
    logoutTitle: 'Cerrar Sesión',
    logoutConfirmLocal: 'Tus plantas están guardadas en este dispositivo y seguirán aquí cuando regreses. Puedes iniciar sesión con Google más tarde para sincronizar tus datos en la nube.',
    logoutConfirmDrive: '¿Estás seguro de que quieres cerrar sesión? Necesitarás iniciar sesión de nuevo para acceder a tus plantas.',
    exit: 'Salir',
    tryDifferentSearch: 'Prueba con un término de búsqueda diferente',
    noPlantsInstruction: 'Para ver tu biblioteca de plantas, agrega tu primera planta usando el botón naranja en la esquina inferior derecha.',
    addNewPlant: 'Agregar una nueva planta',
    normalCards: 'Tarjetas normales',
    compactCards: 'Tarjetas compactas',
    listViewLabel: 'Vista de lista',
    unnamedPlant: 'Planta sin nombre',
    skipToLibrary: 'Ir a la biblioteca de plantas',
    saving: 'Guardando...',
    viewDetails: 'Ver detalles',
    deleteThisPlant: '¿Eliminar esta planta?',
    loginSubtitle1: 'Tu compañero personal para el cuidado de plantas.',
    loginSubtitle2: 'Registra, identifica y cuida tus amigos verdes.',
    getStarted: 'Comenzar',
    loginSignInDesc: 'Inicia sesión con Google para sincronizar tus plantas entre dispositivos',
    continueWithGoogle: 'Continuar con Google',
    or: 'o',
    idRatherNot: 'Prefiero no hacerlo',
    onDeviceStorage: 'Almacenamiento en dispositivo (sin inicio de sesión)',
    acknowledgeEach: 'Por favor confirma cada punto antes de continuar:',
    continueToLocalMode: 'Continuar en modo local',
    acknowledgeAll: 'Confirmar todo',
    aboutAndInstructions: 'Información e instrucciones',
    termsOfService: 'Términos de servicio',
    privacyPolicy: 'Política de privacidad',
    aiIdentify: 'Identificar con IA',
    cloudSync: 'Sincronizar en la nube',
    careTips: 'Consejos de cuidado',
    aiIdentifyDesc: 'Toma una foto y nuestra IA identificará tu planta al instante',
    cloudSyncDesc: 'Tu biblioteca de plantas se guarda en tu Google Drive',
    careTipsDesc: 'Obtén detalles de riego, luz y humedad personalizados',
    localWarning1: 'Tus datos de plantas se almacenarán <strong>solo en este dispositivo</strong>, en este navegador.',
    localWarning2: '<strong>Borrar los datos del navegador eliminará permanentemente todas tus plantas.</strong>',
    localWarning3: 'Estás limitado a <strong>100 plantas</strong> (o menos si tu dispositivo tiene poco almacenamiento).',
    localWarning4: 'Tus datos <strong>no se sincronizarán</strong> entre dispositivos.',
    localWarning5: 'Puedes iniciar sesión con Google más tarde para mover tus datos a la nube.',
    bulkEdit: 'Edición masiva',
    selected: 'seleccionados',
    selectAll: 'Seleccionar todos',
    deselectAll: 'Deseleccionar todos',
    chooseField: 'Elegir campo',
    bulkEditBarLabel: 'Edición masiva',
    chooseValue: 'Elegir valor',
    enterValue: 'Ingresar valor...',
    applying: 'Aplicando...',
    applyToSelected: 'Aplicar',
    exitBulkEdit: 'Salir de edición masiva',
    bulkEditConfirmTitle: 'Confirmar edición masiva',
    bulkEditConfirmDesc: '¿Actualizar {field} a "{value}" para {count} planta(s) seleccionada(s)?',
    applyChanges: 'Aplicar cambios',
    bulkUpdateSuccess: '{count} planta(s) actualizada(s) con éxito',
    bulkUpdateFailed: 'Error en la actualización masiva',
    deleteSelected: 'Eliminar seleccionados',
    bulkDeleteConfirmTitle: 'Confirmar eliminación masiva',
    bulkDeleteConfirmDesc: '¿Eliminar permanentemente {count} planta(s) seleccionada(s)? Esto no se puede deshacer.',
    bulkDeleteSuccess: '{count} planta(s) eliminada(s) con éxito',
    bulkDeleteFailed: 'Error en la eliminación masiva',
  },
  fr: {
    appName: 'Mon Inventaire Personnel de Plantes',
    appTagline: 'Votre compagnon personnel pour l\'entretien des plantes.',
    appTagline2: 'Suivez, identifiez et prenez soin de vos amis verts.',
    signInPrompt: 'Connectez-vous avec Google pour synchroniser vos plantes',
    localModeButton: 'Je préfère ne pas',
    localWarningTitle: 'Avant de continuer sans compte :',
    continueLocalMode: 'Continuer en mode local',
    cancelLocalMode: 'Annuler',
    myPlants: 'Mes Plantes',
    searchPlants: 'Rechercher des plantes...',
    noPlants: 'Pas encore de plantes',
    noPlantsDesc: 'Appuyez sur le bouton + pour ajouter votre première plante !',
    noResults: 'Aucune plante ne correspond à votre recherche',
    incomplete: 'Incomplet',
    showing: 'Affichage',
    of: 'sur',
    plants: 'plantes',
    plant: 'plante',
    addPlant: 'Ajouter une Plante',
    editPlant: 'Modifier la Plante',
    edit: 'Modifier',
    addPhoto: 'Ajouter Photo',
    replacePhoto: 'Remplacer Photo',
    photoUpdated: 'Photo mise à jour',
    photoAdded: 'Photo ajoutée',
    photoReplaced: 'Photo remplacée',
    photoUpdateFailed: 'Échec de la mise à jour de la photo',
    batchAdd: 'Ajout par lot',
    fromCamera: 'Depuis la Caméra',
    mergeIntoAnother: "Fusionner avec une autre plante",
    mergeDialogTitle: "Fusionner ces deux plantes",
    mergeDialogBlurb: "La GARDÉE reste dans votre bibliothèque et absorbe tout de l'autre plante. Choisissez quelle valeur gagne pour chaque champ. Les photos se combinent jusqu'à 5 maximum.",
    mergeDialogBlurbV2: "Vérifiez que les noms commun et scientifique correspondent, choisissez les photos à garder et sélectionnez une couverture. L'autre plante sera absorbée.",
    mergeKeeper: "Gardée (reste)",
    mergeAbsorbedTitle: "Absorbée (supprimée)",
    mergeAbsorbed: "Absorbée",
    mergeKeepThis: "Gardée",
    mergePhotos: "photo(s)",
    mergeConfirm: "Fusionner les plantes",
    mergeInProgress: "Fusion…",
    mergeFailed: "Échec de la fusion",
    mergeSuccess: "Plantes fusionnées.",
    mergeSuccessWithDrop: "Fusionnées. {n} photo(s) supplémentaire(s) écartée(s) (max 5).",
    mergeSameError: "Impossible de fusionner une plante avec elle-même.",
    mergeDiffHeader: "{n} champ(s) de soins diffèrent — choisissez-en un",
    mergeNoDiff: "Les deux plantes ont des informations de soins identiques — rien à réconcilier.",
    mergePhotoWarning: "⚠ {n} photo(s) supplémentaire(s) seront écartées (max 5 par plante).",
    mergeEmpty: "—",
    mergeAction: "Fusionner",
    mergePickerTitle: "Fusionner avec une autre plante",
    mergePickerBlurb: "Choisissez la plante qui doit rester (la Gardée). {name} sera absorbée par elle.",
    mergePickerSearch: "Rechercher par nom…",
    mergePickerSuggested: "Doublons probables",
    mergePickerEmpty: "Aucune autre plante correspondante.",
    mergeSelected: "Fusionner la sélection",
    mergeRequiresTwo: "Sélectionnez exactement 2 plantes pour fusionner",
    mergePlantsNotFound: "Plantes sélectionnées introuvables",
    duplicateBadge: "Doublon ?",
    duplicateBannerBody: "Deux entrées partagent le nom « {name} ». Les fusionner ?",
    fromGallery: 'Depuis la Galerie',
    enterManually: 'Saisir manuellement sans photo',
    doneCropping: 'Terminé',
    rotate: 'Pivoter',
    cancel: 'Annuler',
    skip: 'Passer',
    savePlant: 'Enregistrer la Plante',
    saveAndNext: 'Enregistrer et Suivant',
    completeLater: 'Compléter Plus Tard',
    delete: 'Supprimer',
    deleting: 'Suppression...',
    undoChanges: 'Annuler les modifications',
    cropInstructions: 'Comment recadrer :',
    cropDesc: 'Cliquez et faites glisser n\'importe où sur l\'image pour dessiner une zone de recadrage. Faites glisser les poignées pour redimensionner. Cliquez sur "Terminé" quand vous êtes prêt.',
    identifyingPlant: 'Identification de la plante...',
    looksCorrect: 'C\'est Correct',
    recrop: 'Recadrer',
    notRight: 'Ce n\'est pas correct',
    aiThinksThisIs: 'L\'IA pense que c\'est :',
    wrongEnterCorrectName: 'Incorrect ? Entrez le nom correct :',
    pleaseEnterName: 'Veuillez entrer un nom',
    aiAutoFill: 'Remplir avec l\'IA',
    aiAutoFillHint: 'Entrez un nom ci-dessus, puis cliquez pour remplir automatiquement les détails d\'entretien avec l\'IA.',
    addNewPlantTitle: 'Ajouter Nouvelle Plante',
    cropAndRotate: 'Recadrer et Pivoter la Photo',
    aiIdentificationTitle: 'Identification IA',
    plantDetailsTitle: 'Détails de la Plante',
    allDone: 'Terminé !',
    processedPlants: '{count} plante(s) traitée(s) :',
    duplicateFound: 'Doublon Trouvé',
    youAlreadyHave: 'Vous avez déjà "{name}" dans votre bibliothèque.',
    replaceExisting: 'Remplacer l\'existant par celui-ci',
    keepBoth: 'Garder les deux',
    discardThisOne: 'Supprimer celui-ci, garder l\'existant',
    photoXOfY: 'Photo {current} sur {total}',
    skippedLabel: '(ignorée)',
    returningToSkipped: 'Retour aux photos ignorées...',
    savedAsIncompleteNext: 'Enregistrée comme incomplète. Passage à la suivante...',
    savedAsIncompleteLater: 'Enregistrée comme incomplète. Vous pourrez la terminer plus tard depuis la bibliothèque.',
    keptExistingNext: 'L\'existante est conservée. Passage à la photo suivante...',
    keptExistingPlant: 'Plante existante conservée.',
    skippedWillReturn: 'Ignorée — on y reviendra plus tard',
    removeThisPhoto: 'Supprimer cette photo',
    removePhotoTitle: 'Supprimer cette photo ?',
    removePhotoDesc: 'Cette photo sera ignorée et ne sera pas ajoutée. Les autres photos de ce lot restent dans la file.',
    removePhotoConfirm: 'Supprimer la photo',
    photoRemovedWithCount: 'Photo supprimée — {n} restante(s)',
    photoRemoved: 'Photo supprimée',
    photoRestored: 'Photo restaurée',
    photoDupLibrary: 'Cette photo exacte est déjà dans votre bibliothèque sous « {name} ». Vous pouvez l\'ajouter quand même ou la supprimer.',
    photoDupBatch: 'Vous avez déjà ajouté cette photo plus tôt dans ce lot. Vous pouvez l\'ajouter quand même ou la supprimer.',
    anotherPlant: 'une autre plante',
    draftDiscarded: 'Brouillon supprimé',
    draftRestored: 'Brouillon restauré',
    aiDisclaimer: 'Les détails d\'entretien sont générés par IA (Google Gemini) et peuvent ne pas être précis. Modifiez les champs selon vos besoins.',
    aiDisclaimerDetail: 'Les détails d\'entretien sont générés par IA utilisant Google Gemini et peuvent contenir des erreurs. Faites vos propres recherches si la précision scientifique est importante.',
    commonName: 'Nom Commun',
    scientificName: 'Nom Scientifique',
    watering: 'Arrosage',
    light: 'Lumière',
    humidity: 'Humidité',
    temperature: 'Température',
    toxicity: 'Toxicité',
    growthRate: 'Taux de Croissance',
    blooming: 'Floraison',
    bloomSeason: 'Saison de floraison',
    bloomDuration: 'Durée de floraison',
    bloomsIndoors: 'Fleurit à l\'intérieur ?',
    bloomTips: 'Conseils de floraison',
    toxicityNotes: 'Notes de toxicité',
    dormancyNotes: 'Notes de dormance',
    bloomLasts: 'Dure',
    bloomNotIndoors: 'Ne fleurit pas à l\'intérieur',
    bloomRarelyIndoors: 'Fleurit rarement à l\'intérieur',
    dormancy: 'Dormance',
    dormantNow: 'En dormance',
    needsDormancy: 'Nécessite dormance',
    dormancyBannerOne: '1 plante est en dormance ce mois-ci.',
    dormancyBannerMany: '{count} plantes sont en dormance ce mois-ci.',
    dormancyBannerAction: 'Les afficher',
    backfillPromptOne: '1 plante a des détails de soins manquants.',
    backfillPromptMany: '{count} plantes ont des détails de soins manquants.',
    backfillPromptAction: 'Les compléter →',
    iconLegend: 'Légende des icônes',
    show: 'Afficher',
    hide: 'Masquer',
    legendCareSection: 'Détails d\'entretien',
    legendLibrarySection: 'Contrôles de la bibliothèque',
    legendFamily: 'Famille botanique (par ex. Araceae, Cactaceae).',
    legendPlantType: 'Type de croissance : succulente, plante grimpante, plante vivace, etc.',
    legendWatering: 'Fréquence et quantité d\'arrosage pour cette plante.',
    legendLight: 'Niveau de lumière préféré, de faible à plein soleil.',
    legendHumidity: 'Plage d\'humidité qui convient à la plante.',
    legendTemperature: 'Plage de température idéale en °F et °C.',
    legendToxicity: 'Toxicité éventuelle pour animaux, humains ou reptiles.',
    legendEnvironment: 'Maison classique, terrarium préféré ou terrarium obligatoire.',
    legendGrowthRate: 'Croissance lente, modérée ou rapide.',
    legendDormancy: 'Période de repos automne/hiver — chute des feuilles ou croissance ralentie normales.',
    aiCareNote: 'Note IA',
    legendAiNote: 'Informations générées par IA — vérifiez auprès de sources fiables.',
    legendIncomplete: 'Compléter plus tard',
    legendIncompleteHint: 'Plante enregistrée mais photos ou détails manquants.',
    legendPhoto: 'Ajouter / remplacer une photo',
    legendPhotoHint: 'Jusqu\'à 5 photos par plante.',
    legendArchive: 'Archiver',
    legendArchiveHint: 'Retirer une plante de la bibliothèque principale sans la supprimer.',
    legendTerrarium: 'Filtre terrarium',
    legendTerrariumHint: 'Afficher uniquement les plantes de terrarium ou de véranda.',
    legendDormant: 'Filtre dormance',
    legendDormantHint: 'Afficher uniquement les plantes actuellement en dormance.',
    legendSearchPlaceholder: 'Rechercher une icône…',
    legendNoResults: 'Aucune icône ne correspond à votre recherche.',
    environment: 'Environnement',
    terrariumOnly: 'Plantes de terrarium',
    showAllPlants: 'Afficher toutes les plantes',
    readMore: 'Voir plus',
    showLess: 'Voir moins',
    lastSyncedLabel: 'Dernière synchro.',
    refreshNow: 'Actualiser',
    refreshSyncing: 'Actualisation\u2026',
    refreshOffline: 'Hors ligne — reconnectez-vous pour actualiser.',
    offlineCacheTitle: 'Cache hors ligne',
    offlineCacheBlurb: 'Une copie en lecture seule de votre bibliothèque conservée sur cet appareil pour la consulter hors ligne.',
    offlineCacheStats: '{count} {plantWord} \u00b7 {size} \u00b7 enregistrée {when}',
    offlineCacheClear: 'Vider le cache hors ligne',
    offlineCacheCleared: 'Cache hors ligne vidé',
    offlineCacheClearFailed: 'Impossible de vider le cache hors ligne',
    pendingSyncPill: '{n} modifications à synchroniser',
    pendingSyncPillOne: '1 modification à synchroniser',
    pendingSyncTitle: 'Modifications en attente de synchronisation',
    pendingSyncBlurbOnline: 'Ces modifications sont enregistrées sur cet appareil et seront synchronisées automatiquement.',
    pendingSyncBlurbOffline: 'Vous êtes hors ligne. Elles seront synchronisées dès votre reconnexion.',
    pendingSyncRetry: 'Réessayer maintenant',
    pendingSyncSyncing: 'Synchronisation\u2026',
    pendingSyncDiscard: 'Annuler cette modification',
    pendingSyncDiscardAll: 'Tout annuler',
    pendingSyncDiscardAllConfirmTitle: 'Annuler toutes les modifications en attente ?',
    pendingSyncDiscardAllConfirmBody: 'Cela supprime {n} modifications en attente de synchronisation et les annule sur cet appareil.',
    pendingSyncDiscardAllConfirmBodyOne: 'Cela supprime 1 modification en attente de synchronisation et l’annule sur cet appareil.',
    pendingSyncDiscardAllToast: 'Toutes les modifications en attente ont été annulées',
    aboutTocTitle: 'Sur cette page',
    pendingSyncViewDetails: 'Détails',
    allChangesSynced: 'Toutes les modifications synchronisées',
    addOfflineNotice: 'Vous êtes hors ligne : les nouvelles plantes nécessitent une connexion. Modifier, archiver et supprimer fonctionnent et se synchronisent au retour.',
    pendingWaitingFor: 'en attente {time}',
    syncProgress: '{done} sur {total} synchronisés',
    syncHistoryTitle: 'Activité de synchronisation récente',
    syncHistoryClear: 'Effacer',
    syncStatusSynced: 'Synchronisé',
    syncStatusConflict: 'Conflit',
    syncStatusGaveup: 'Échec',
    syncStatusDiscarded: 'Annulé',
    discardUndo: 'Annuler',
    changeDiscarded: 'Modification annulée',
    syncSyncedOne: '1 modification synchronisée',
    syncSyncedMany: '{n} modifications synchronisées',
    syncConflictOne: 'Impossible de synchroniser « {name} » : modifiée ou supprimée sur un autre appareil.',
    syncConflictMany: '{n} modifications non synchronisées : ces plantes ont été modifiées ou supprimées sur un autre appareil.',
    syncGaveupOne: 'Synchronisation de « {name} » abandonnée après plusieurs tentatives : veuillez recommencer.',
    syncGaveupMany: '{n} modifications n\u2019ont pas pu être enregistrées après plusieurs tentatives et ont été abandonnées.',
    syncRetryOne: '1 modification non synchronisée : nouvelle tentative à venir',
    syncRetryMany: '{n} modifications non synchronisées : nouvelle tentative à venir',
    offlineHelpTitle: 'Hors ligne et synchronisation',
    offlineHelpBody: 'Hors ligne, vous pouvez parcourir et modifier, archiver ou supprimer des plantes : ces changements sont mis en file et synchronisés à la reconnexion. Ajouter une nouvelle plante nécessite une connexion.',
    offlineHelpLearnMore: 'En savoir plus',
    aboutSharingTitle: 'Partager vos plantes',
    aboutSharingBody: 'Partagez une seule plante en image enrichie, ou toute votre bibliothèque en PDF : en un coup d\u2019œil (photos + noms), en détail (une page par plante) ou noms seuls. Chaque PDF inclut un QR code scannable, un lien et votre mot de bienvenue. Les destinataires ouvrent une vue « grow-along » en lecture seule ; rien de votre bibliothèque ne change et ils ne peuvent pas la modifier.',
    savedOfflineToast: 'Enregistré hors ligne — synchronisation à la reconnexion',
    offlineWriteBlocked: 'Vous êtes hors ligne — reconnectez-vous pour enregistrer.',
    done: 'Compris',
    pendingOpEdit: 'Modifier « {name} »',
    pendingOpArchive: 'Archiver « {name} »',
    pendingOpDelete: 'Supprimer « {name} »',
    pendingOpBulkUpdate: 'Mettre à jour {count} {plantWord}',
    pendingOpBulkDelete: 'Supprimer {count} {plantWord}',
    dateAdded: 'Date d\'ajout',
    addedOn: 'Ajouté',
    family: 'Famille',
    plantType: 'Type',
    careDetails: 'Détails d\'Entretien',
    learnMore: 'En savoir plus de sources fiables',
    tapToEnlarge: 'Appuyez pour agrandir',
    translating: 'Traduction...',
    retryTranslation: 'Réessayer la traduction',
    settings: 'Paramètres',
    geminiApiKey: 'Clé API Google Gemini',
    photoQuality: 'Qualité Photo',
    fontSize: 'Taille de Police',
    language: 'Langue',
    languageDesc: 'Définit la langue d\'affichage de l\'application. Par défaut : anglais (US).',
    saveSettings: 'Enregistrer les Paramètres',
    downloadLibrary: 'Télécharger la bibliothèque',
    downloadLibraryDesc: 'Le format CSV est idéal pour réimporter les données dans un tableur ou d\'autres outils. Le PDF fournit une copie imprimable formatée avec une prise en charge correcte des noms de plantes non latins.',
    download: 'Télécharger',
    downloading: 'Téléchargement…',
    sharePlants: 'Partager',
    preloadPhotos: 'Précharger toutes les photos',
    photosOnDevice: 'Vos photos sont déjà sur cet appareil',
    noPhotosToPreload: 'Aucune photo à précharger',
    preloadingPhotos: 'Préchargement des photos…',
    photosReady: 'Photos prêtes',
    couldNotLoad: 'indisponibles',
    photoReadFailed: 'Impossible de lire cette photo — sélectionne-la à nouveau',
    backToTop: 'Retour en haut',
    readingProgress: 'Progression de lecture',
    linkCopied: 'Lien copié',
    copyLinkToSection: 'Copier le lien vers cette section',
    copyPlantLink: 'Copier le lien de partage',
    copyLinkFailed: 'Impossible de copier le lien',
    qrCreateFailed: 'Impossible de créer le code QR',
    sortNameAsc: 'Nom (A → Z)',
    sortNameDesc: 'Nom (Z → A)',
    thenBy: 'Puis par',
    thenByPlaceholder: 'Puis par…',
    withPhotos: 'Avec photos',
    noPhotos: 'Sans photos',
    export: 'Exporter CSV',
    signOut: 'Déconnexion',
    back: 'Retour',
    previous: 'Précédent',
    next: 'Suivant',
    page: 'Page',
    perPage: 'Par page',
    grouped: 'Groupé',
    by: 'par',
    needsAttention: 'Nécessite Attention',
    toComplete: 'à compléter',
    found: 'Trouvées',
    updateAll: 'Tout Mettre à Jour',
    updating: 'Mise à jour...',
    dismiss: 'Ignorer',
    missingFamilyType: 'sans information de Famille et Type.',
    deviceOnlyMode: 'Mode appareil uniquement',
    plantsUsed: 'plantes utilisées',
    signInGoogleSync: 'Connectez-vous avec Google pour synchroniser',
    connectGoogleDrive: 'Connecter Google Drive',
    connectDriveDesc: 'Vos plantes et photos seront stockées en sécurité dans votre Google Drive. Cela garde vos données privées et synchronisées entre les appareils.',
    deletePlant: 'Supprimer la Plante',
    deleteConfirmLocal: 'Voulez-vous vraiment supprimer cette plante ? Elle sera définitivement supprimée de votre appareil. Cette action est irréversible.',
    deleteConfirmDrive: 'Voulez-vous vraiment supprimer cette plante ? Elle sera définitivement supprimée ainsi que sa photo de votre Google Drive. Cette action est irréversible.',
    exitLocalMode: 'Quitter le Mode Local',
    logoutTitle: 'Déconnexion',
    logoutConfirmLocal: 'Vos plantes sont sauvegardées sur cet appareil et seront toujours là quand vous reviendrez. Vous pourrez vous connecter avec Google plus tard pour synchroniser vos données.',
    logoutConfirmDrive: 'Voulez-vous vraiment vous déconnecter ? Vous devrez vous reconnecter pour accéder à vos plantes.',
    exit: 'Quitter',
    tryDifferentSearch: 'Essayez un autre terme de recherche',
    noPlantsInstruction: 'Pour voir votre bibliothèque de plantes, ajoutez votre première plante en utilisant le bouton orange en bas à droite.',
    addNewPlant: 'Ajouter une nouvelle plante',
    normalCards: 'Cartes normales',
    compactCards: 'Cartes compactes',
    listViewLabel: 'Vue liste',
    unnamedPlant: 'Plante sans nom',
    skipToLibrary: 'Aller à la bibliothèque de plantes',
    saving: 'Enregistrement...',
    viewDetails: 'Voir les détails',
    deleteThisPlant: 'Supprimer cette plante ?',
    loginSubtitle1: 'Votre compagnon personnel pour le soin des plantes.',
    loginSubtitle2: 'Suivez, identifiez et choyez vos amis verts.',
    getStarted: 'Commencer',
    loginSignInDesc: 'Connectez-vous avec Google pour synchroniser vos plantes entre appareils',
    continueWithGoogle: 'Continuer avec Google',
    or: 'ou',
    idRatherNot: 'Je préfère pas',
    onDeviceStorage: 'Stockage sur appareil (sans connexion)',
    acknowledgeEach: 'Veuillez confirmer chaque point avant de continuer :',
    continueToLocalMode: 'Continuer en mode local',
    acknowledgeAll: 'Tout confirmer',
    aboutAndInstructions: 'À propos et instructions',
    termsOfService: "Conditions d'utilisation",
    privacyPolicy: 'Politique de confidentialité',
    aiIdentify: 'Identifier par IA',
    cloudSync: 'Synchronisation cloud',
    careTips: "Conseils d'entretien",
    aiIdentifyDesc: 'Prenez une photo et notre IA identifiera votre plante instantanément',
    cloudSyncDesc: 'Votre bibliothèque de plantes est stockée dans votre Google Drive',
    careTipsDesc: "Obtenez des conseils personnalisés d'arrosage, de lumière et d'humidité",
    localWarning1: 'Vos données seront stockées <strong>uniquement sur cet appareil</strong>, dans ce navigateur.',
    localWarning2: '<strong>Effacer les données du navigateur supprimera définitivement toutes vos plantes.</strong>',
    localWarning3: 'Vous êtes limité à <strong>100 plantes</strong> (ou moins si votre appareil a peu de stockage).',
    localWarning4: 'Vos données <strong>ne se synchroniseront pas</strong> entre les appareils.',
    localWarning5: 'Vous pourrez vous connecter avec Google plus tard pour transférer vos données.',
    bulkEdit: 'Modification groupée',
    selected: 'sélectionnés',
    selectAll: 'Tout sélectionner',
    deselectAll: 'Tout désélectionner',
    chooseField: 'Choisir un champ',
    bulkEditBarLabel: 'Édition groupée',
    chooseValue: 'Choisir une valeur',
    enterValue: 'Entrer une valeur...',
    applying: 'Application...',
    applyToSelected: 'Appliquer',
    exitBulkEdit: 'Quitter la modification groupée',
    bulkEditConfirmTitle: 'Confirmer la modification groupée',
    bulkEditConfirmDesc: 'Mettre à jour {field} à "{value}" pour {count} plante(s) sélectionnée(s) ?',
    applyChanges: 'Appliquer les modifications',
    bulkUpdateSuccess: '{count} plante(s) mise(s) à jour avec succès',
    bulkUpdateFailed: 'Échec de la mise à jour groupée',
    deleteSelected: 'Supprimer la sélection',
    bulkDeleteConfirmTitle: 'Confirmer la suppression groupée',
    bulkDeleteConfirmDesc: 'Supprimer définitivement {count} plante(s) sélectionnée(s) ? Cette action est irréversible.',
    bulkDeleteSuccess: '{count} plante(s) supprimée(s) avec succès',
    bulkDeleteFailed: 'Échec de la suppression groupée',
  },
  de: {
    appName: 'Mein Persönliches Pflanzeninventar',
    appTagline: 'Dein persönlicher Begleiter für die Pflanzenpflege.',
    appTagline2: 'Verfolge, identifiziere und pflege deine grünen Freunde.',
    signInPrompt: 'Mit Google anmelden um Pflanzen zu synchronisieren',
    localModeButton: 'Lieber nicht',
    localWarningTitle: 'Bevor du ohne Konto fortfährst:',
    continueLocalMode: 'Im lokalen Modus fortfahren',
    cancelLocalMode: 'Abbrechen',
    myPlants: 'Meine Pflanzen',
    searchPlants: 'Pflanzen suchen...',
    noPlants: 'Noch keine Pflanzen',
    noPlantsDesc: 'Tippe auf den + Button um deine erste Pflanze hinzuzufügen!',
    noResults: 'Keine Pflanzen gefunden',
    incomplete: 'Unvollständig',
    showing: 'Zeige',
    of: 'von',
    plants: 'Pflanzen',
    plant: 'Pflanze',
    edit: 'Bearbeiten',
    addPlant: 'Pflanze Hinzufügen',
    editPlant: 'Pflanze Bearbeiten',
    addPhoto: 'Foto Hinzufügen',
    replacePhoto: 'Foto Ersetzen',
    photoUpdated: 'Foto aktualisiert',
    photoAdded: 'Foto hinzugefügt',
    photoReplaced: 'Foto ersetzt',
    photoUpdateFailed: 'Foto-Aktualisierung fehlgeschlagen',
    batchAdd: 'Stapel hinzufügen',
    fromCamera: 'Von Kamera',
    mergeIntoAnother: "Mit einer anderen Pflanze zusammenführen",
    mergeDialogTitle: "Diese beiden Pflanzen zusammenführen",
    mergeDialogBlurb: "Die BLEIBENDE Pflanze bleibt in deiner Bibliothek und übernimmt alles von der anderen Pflanze. Wähle, welcher Wert für jedes Feld gewinnt. Fotos werden bis zu 5 kombiniert.",
    mergeDialogBlurbV2: "Prüfe, ob der deutsche und wissenschaftliche Name übereinstimmen, wähle die zu behaltenden Fotos aus und lege eines als Titelbild fest. Die andere Pflanze wird aufgenommen.",
    mergeKeeper: "Bleibt",
    mergeAbsorbedTitle: "Fusioniert (gelöscht)",
    mergeAbsorbed: "Aufgenommen",
    mergeKeepThis: "Bleibt",
    mergePhotos: "Foto(s)",
    mergeConfirm: "Pflanzen zusammenführen",
    mergeInProgress: "Wird zusammengeführt…",
    mergeFailed: "Zusammenführung fehlgeschlagen",
    mergeSuccess: "Pflanzen zusammengeführt.",
    mergeSuccessWithDrop: "Zusammengeführt. {n} zusätzliche Foto(s) verworfen (max. 5).",
    mergeSameError: "Eine Pflanze kann nicht mit sich selbst zusammengeführt werden.",
    mergeDiffHeader: "{n} Pflegefeld(er) unterscheiden sich — eines auswählen",
    mergeNoDiff: "Beide Pflanzen haben identische Pflegeinfos — nichts abzugleichen.",
    mergePhotoWarning: "⚠ {n} zusätzliche Foto(s) werden verworfen (max. 5 pro Pflanze).",
    mergeEmpty: "—",
    mergeAction: "Zusammenführen",
    mergePickerTitle: "Mit einer anderen Pflanze zusammenführen",
    mergePickerBlurb: "Wähle die Pflanze, die bleiben soll. {name} wird darin aufgenommen.",
    mergePickerSearch: "Nach Namen suchen…",
    mergePickerSuggested: "Wahrscheinliche Duplikate",
    mergePickerEmpty: "Keine anderen passenden Pflanzen.",
    mergeSelected: "Auswahl zusammenführen",
    mergeRequiresTwo: "Wähle genau 2 Pflanzen zum Zusammenführen",
    mergePlantsNotFound: "Ausgewählte Pflanzen nicht gefunden",
    duplicateBadge: "Duplikat?",
    duplicateBannerBody: "Zwei Einträge teilen den Namen „{name}\". Zusammenführen?",
    fromGallery: 'Aus Galerie',
    enterManually: 'Manuell ohne Foto eingeben',
    doneCropping: 'Fertig',
    rotate: 'Drehen',
    cancel: 'Abbrechen',
    skip: 'Überspringen',
    savePlant: 'Pflanze Speichern',
    saveAndNext: 'Speichern & Weiter',
    completeLater: 'Später Vervollständigen',
    delete: 'Löschen',
    deleting: 'Löschen...',
    undoChanges: 'Änderungen rückgängig',
    cropInstructions: 'So wird zugeschnitten:',
    cropDesc: 'Klicke und ziehe irgendwo auf dem Bild um einen Zuschneidebereich zu zeichnen. Ziehe die Ecken oder Kanten zum Ändern der Größe.',
    identifyingPlant: 'Pflanze wird identifiziert...',
    looksCorrect: 'Sieht Richtig Aus',
    recrop: 'Neu Zuschneiden',
    notRight: 'Das stimmt nicht',
    aiThinksThisIs: 'Die KI denkt, das ist:',
    wrongEnterCorrectName: 'Falsch? Geben Sie den richtigen Namen ein:',
    pleaseEnterName: 'Bitte geben Sie einen Namen ein',
    aiAutoFill: 'Mit KI ausfüllen',
    aiAutoFillHint: 'Geben Sie oben einen Namen ein und klicken Sie, um die Pflegedetails automatisch mit KI auszufüllen.',
    addNewPlantTitle: 'Neue Pflanze Hinzufügen',
    cropAndRotate: 'Foto Zuschneiden und Drehen',
    aiIdentificationTitle: 'KI-Identifizierung',
    plantDetailsTitle: 'Pflanzendetails',
    allDone: 'Alles Fertig!',
    processedPlants: '{count} Pflanze(n) verarbeitet:',
    duplicateFound: 'Duplikat Gefunden',
    youAlreadyHave: 'Sie haben bereits "{name}" in Ihrer Bibliothek.',
    replaceExisting: 'Vorhandene durch diese ersetzen',
    keepBoth: 'Beide behalten',
    discardThisOne: 'Diese verwerfen, vorhandene behalten',
    photoXOfY: 'Foto {current} von {total}',
    skippedLabel: '(übersprungen)',
    returningToSkipped: 'Zurück zu übersprungenen Fotos...',
    savedAsIncompleteNext: 'Als unvollständig gespeichert. Weiter...',
    savedAsIncompleteLater: 'Als unvollständig gespeichert. Sie können sie später in der Bibliothek fertigstellen.',
    keptExistingNext: 'Vorhandene behalten. Weiter zum nächsten Foto...',
    keptExistingPlant: 'Vorhandene Pflanze behalten.',
    skippedWillReturn: 'Übersprungen — wird später nachgeholt',
    removeThisPhoto: 'Dieses Foto entfernen',
    removePhotoTitle: 'Dieses Foto entfernen?',
    removePhotoDesc: 'Dieses Foto wird verworfen und nicht hinzugefügt. Die anderen Fotos in diesem Stapel bleiben in der Warteschlange.',
    removePhotoConfirm: 'Foto entfernen',
    photoRemovedWithCount: 'Foto entfernt — noch {n} übrig',
    photoRemoved: 'Foto entfernt',
    photoRestored: 'Foto wiederhergestellt',
    photoDupLibrary: 'Genau dieses Foto ist bereits als „{name}" in deiner Bibliothek. Du kannst es trotzdem hinzufügen oder entfernen.',
    photoDupBatch: 'Du hast dieses Foto in diesem Stapel bereits hinzugefügt. Du kannst es trotzdem hinzufügen oder entfernen.',
    anotherPlant: 'eine andere Pflanze',
    draftDiscarded: 'Entwurf verworfen',
    draftRestored: 'Entwurf wiederhergestellt',
    aiDisclaimer: 'Pflegedetails werden von KI (Google Gemini) generiert und sind möglicherweise nicht genau. Bearbeite die Felder nach Bedarf.',
    aiDisclaimerDetail: 'Pflegedetails werden von KI generiert und können Fehler enthalten. Recherchiere selbst wenn wissenschaftliche Genauigkeit wichtig ist.',
    commonName: 'Allgemeiner Name',
    scientificName: 'Wissenschaftlicher Name',
    watering: 'Bewässerung',
    light: 'Licht',
    humidity: 'Luftfeuchtigkeit',
    temperature: 'Temperatur',
    toxicity: 'Giftigkeit',
    growthRate: 'Wachstumsrate',
    blooming: 'Blüte',
    bloomSeason: 'Blütezeit',
    bloomDuration: 'Blühdauer',
    bloomsIndoors: 'Blüht drinnen?',
    bloomTips: 'Blüh-Tipps',
    toxicityNotes: 'Toxizitätshinweise',
    dormancyNotes: 'Ruhezeit-Hinweise',
    bloomLasts: 'Hält',
    bloomNotIndoors: 'Blüht nicht drinnen',
    bloomRarelyIndoors: 'Blüht selten drinnen',
    dormancy: 'Ruhephase',
    dormantNow: 'In Ruhe',
    needsDormancy: 'Braucht Ruhephase',
    dormancyBannerOne: '1 Pflanze befindet sich diesen Monat in ihrer Ruhephase.',
    dormancyBannerMany: '{count} Pflanzen befinden sich diesen Monat in ihrer Ruhephase.',
    dormancyBannerAction: 'Anzeigen',
    backfillPromptOne: 'Bei 1 Pflanze fehlen Pflegedetails.',
    backfillPromptMany: 'Bei {count} Pflanzen fehlen Pflegedetails.',
    backfillPromptAction: 'Ausfüllen →',
    iconLegend: 'Symbol-Legende',
    show: 'Anzeigen',
    hide: 'Ausblenden',
    legendCareSection: 'Pflegehinweise',
    legendLibrarySection: 'Bibliothek-Steuerung',
    legendFamily: 'Botanische Familie (z. B. Araceae, Cactaceae).',
    legendPlantType: 'Wuchsform: Sukkulente, Kletterpflanze, Staude usw.',
    legendWatering: 'Wie oft und wie viel diese Pflanze gegossen werden sollte.',
    legendLight: 'Bevorzugtes Lichtniveau, von wenig Licht bis volle Sonne.',
    legendHumidity: 'Luftfeuchtigkeitsbereich, in dem sich die Pflanze wohlfühlt.',
    legendTemperature: 'Idealer Temperaturbereich in °F und °C.',
    legendToxicity: 'Giftigkeit für Haustiere, Menschen oder Reptilien.',
    legendEnvironment: 'Normaler Haushalt, Terrarium bevorzugt oder Terrarium erforderlich.',
    legendGrowthRate: 'Langsam, mäßig oder schnell wachsend.',
    legendDormancy: 'Herbst-/Winterruhe — Blattfall oder langsameres Wachstum sind normal.',
    aiCareNote: 'KI-Hinweis',
    legendAiNote: 'KI-generierte Pflegehinweise — bitte mit vertrauenswürdigen Quellen abgleichen.',
    legendIncomplete: 'Später vervollständigen',
    legendIncompleteHint: 'Pflanze ist gespeichert, aber Fotos oder Pflegedetails fehlen.',
    legendPhoto: 'Foto hinzufügen / ersetzen',
    legendPhotoHint: 'Bis zu 5 Fotos pro Pflanze.',
    legendArchive: 'Archivieren',
    legendArchiveHint: 'Pflanze aus der Hauptbibliothek entfernen, ohne sie zu löschen.',
    legendTerrarium: 'Terrarien-Filter',
    legendTerrariumHint: 'Nur Pflanzen anzeigen, die ein Terrarium brauchen oder bevorzugen.',
    legendDormant: 'Ruhephasen-Filter',
    legendDormantHint: 'Nur Pflanzen anzeigen, die sich gerade in der Ruhephase befinden.',
    legendSearchPlaceholder: 'Symbole suchen…',
    legendNoResults: 'Keine Symbole passen zu deiner Suche.',
    environment: 'Umgebung',
    terrariumOnly: 'Terrarium-Pflanzen',
    showAllPlants: 'Alle Pflanzen anzeigen',
    readMore: 'Mehr anzeigen',
    showLess: 'Weniger anzeigen',
    lastSyncedLabel: 'Zuletzt synchronisiert',
    refreshNow: 'Jetzt aktualisieren',
    refreshSyncing: 'Aktualisieren\u2026',
    refreshOffline: 'Offline – zum Aktualisieren erneut verbinden.',
    offlineCacheTitle: 'Offline-Cache',
    offlineCacheBlurb: 'Eine schreibgeschützte Kopie deiner Bibliothek auf diesem Gerät, damit du auch offline stöbern kannst.',
    offlineCacheStats: '{count} {plantWord} \u00b7 {size} \u00b7 gespeichert {when}',
    offlineCacheClear: 'Offline-Cache leeren',
    offlineCacheCleared: 'Offline-Cache geleert',
    offlineCacheClearFailed: 'Offline-Cache konnte nicht geleert werden',
    pendingSyncPill: '{n} Änderungen warten auf Sync',
    pendingSyncPillOne: '1 Änderung wartet auf Sync',
    pendingSyncTitle: 'Änderungen warten auf Synchronisierung',
    pendingSyncBlurbOnline: 'Diese Änderungen sind auf diesem Gerät gespeichert und werden automatisch synchronisiert.',
    pendingSyncBlurbOffline: 'Du bist offline. Sie werden synchronisiert, sobald du wieder verbunden bist.',
    pendingSyncRetry: 'Jetzt wiederholen',
    pendingSyncSyncing: 'Synchronisieren\u2026',
    pendingSyncDiscard: 'Diese Änderung verwerfen',
    pendingSyncDiscardAll: 'Alle verwerfen',
    pendingSyncDiscardAllConfirmTitle: 'Alle ausstehenden Änderungen verwerfen?',
    pendingSyncDiscardAllConfirmBody: 'Dies entfernt {n} auf die Synchronisierung wartende Änderungen und macht sie auf diesem Gerät rückgängig.',
    pendingSyncDiscardAllConfirmBodyOne: 'Dies entfernt 1 auf die Synchronisierung wartende Änderung und macht sie auf diesem Gerät rückgängig.',
    pendingSyncDiscardAllToast: 'Alle ausstehenden Änderungen verworfen',
    aboutTocTitle: 'Auf dieser Seite',
    pendingSyncViewDetails: 'Details',
    allChangesSynced: 'Alle Änderungen synchronisiert',
    addOfflineNotice: 'Du bist offline: Neue Pflanzen brauchen eine Verbindung. Bearbeiten, Archivieren und Löschen funktionieren und synchronisieren sich bei Rückkehr.',
    pendingWaitingFor: 'wartet {time}',
    syncProgress: '{done} von {total} synchronisiert',
    syncHistoryTitle: 'Letzte Synchronisierungsaktivität',
    syncHistoryClear: 'Löschen',
    syncStatusSynced: 'Synchronisiert',
    syncStatusConflict: 'Konflikt',
    syncStatusGaveup: 'Fehlgeschlagen',
    syncStatusDiscarded: 'Verworfen',
    discardUndo: 'Rückgängig',
    changeDiscarded: 'Änderung verworfen',
    syncSyncedOne: '1 Änderung synchronisiert',
    syncSyncedMany: '{n} Änderungen synchronisiert',
    syncConflictOne: '„{name}“ konnte nicht synchronisiert werden – auf einem anderen Gerät geändert oder gelöscht.',
    syncConflictMany: '{n} Änderungen konnten nicht synchronisiert werden – diese Pflanzen wurden auf einem anderen Gerät geändert oder gelöscht.',
    syncGaveupOne: 'Synchronisierung von „{name}“ nach mehreren Versuchen aufgegeben – bitte erneut durchführen.',
    syncGaveupMany: '{n} Änderungen konnten nach mehreren Versuchen nicht gespeichert werden und wurden verworfen.',
    syncRetryOne: '1 Änderung konnte nicht synchronisiert werden – wird erneut versucht',
    syncRetryMany: '{n} Änderungen konnten nicht synchronisiert werden – werden erneut versucht',
    offlineHelpTitle: 'Offline & Synchronisierung',
    offlineHelpBody: 'Offline kannst du stöbern sowie Pflanzen bearbeiten, archivieren oder löschen – diese Änderungen werden in eine Warteschlange gestellt und bei erneuter Verbindung automatisch synchronisiert. Eine neue Pflanze hinzuzufügen erfordert eine Verbindung.',
    offlineHelpLearnMore: 'Mehr erfahren',
    aboutSharingTitle: 'Pflanzen teilen',
    aboutSharingBody: 'Teile eine einzelne Pflanze als hochwertiges Bild oder deine ganze Bibliothek als PDF – als Überblick (Fotos + Namen), in vollem Detail (eine Seite pro Pflanze) oder nur Namen. Jedes PDF enthält einen scannbaren QR-Code, einen Link und deine Willkommensnotiz. Empfänger öffnen eine schreibgeschützte „Grow-along“-Ansicht; an deiner Bibliothek ändert sich nichts und sie kann nicht bearbeitet werden.',
    savedOfflineToast: 'Offline gespeichert – wird bei erneuter Verbindung synchronisiert',
    offlineWriteBlocked: 'Du bist offline – verbinde dich erneut, um zu speichern.',
    done: 'Verstanden',
    pendingOpEdit: '„{name}“ bearbeiten',
    pendingOpArchive: '„{name}“ archivieren',
    pendingOpDelete: '„{name}“ löschen',
    pendingOpBulkUpdate: '{count} {plantWord} aktualisieren',
    pendingOpBulkDelete: '{count} {plantWord} löschen',
    dateAdded: 'Hinzugefügt am',
    addedOn: 'Hinzugefügt',
    family: 'Familie',
    plantType: 'Typ',
    careDetails: 'Pflegedetails',
    learnMore: 'Mehr erfahren aus seriösen Quellen',
    tapToEnlarge: 'Tippen zum Vergrößern',
    translating: 'Übersetzen...',
    retryTranslation: 'Übersetzung erneut versuchen',
    settings: 'Einstellungen',
    geminiApiKey: 'Google Gemini API-Schlüssel',
    photoQuality: 'Fotoqualität',
    fontSize: 'Schriftgröße',
    language: 'Sprache',
    languageDesc: 'Legt die Anzeigesprache der App fest. Standard ist Englisch (US).',
    saveSettings: 'Einstellungen Speichern',
    downloadLibrary: 'Bibliothek herunterladen',
    downloadLibraryDesc: 'CSV eignet sich am besten für den Reimport in Tabellenkalkulationen oder andere Tools. PDF liefert eine formatierte druckbare Kopie mit korrekter Unterstützung für nicht-lateinische Pflanzennamen.',
    download: 'Herunterladen',
    downloading: 'Wird heruntergeladen…',
    sharePlants: 'Teilen',
    preloadPhotos: 'Alle Fotos vorladen',
    photosOnDevice: 'Deine Fotos sind bereits auf diesem Gerät',
    noPhotosToPreload: 'Keine Fotos zum Vorladen',
    preloadingPhotos: 'Fotos werden vorgeladen…',
    photosReady: 'Fotos bereit',
    couldNotLoad: 'nicht verfügbar',
    photoReadFailed: 'Dieses Foto konnte nicht gelesen werden — bitte erneut auswählen',
    backToTop: 'Nach oben',
    readingProgress: 'Lesefortschritt',
    linkCopied: 'Link kopiert',
    copyLinkToSection: 'Link zu diesem Abschnitt kopieren',
    copyPlantLink: 'Freigabelink kopieren',
    copyLinkFailed: 'Link konnte nicht kopiert werden',
    qrCreateFailed: 'QR-Code konnte nicht erstellt werden',
    sortNameAsc: 'Name (A → Z)',
    sortNameDesc: 'Name (Z → A)',
    thenBy: 'Dann nach',
    thenByPlaceholder: 'Dann nach…',
    withPhotos: 'Mit Fotos',
    noPhotos: 'Ohne Fotos',
    export: 'CSV Exportieren',
    signOut: 'Abmelden',
    back: 'Zurück',
    previous: 'Vorherige',
    next: 'Nächste',
    page: 'Seite',
    perPage: 'Pro Seite',
    grouped: 'Gruppiert',
    by: 'nach',
    needsAttention: 'Benötigt Aufmerksamkeit',
    toComplete: 'zu vervollständigen',
    found: 'Gefunden',
    updateAll: 'Alle Aktualisieren',
    updating: 'Wird aktualisiert...',
    dismiss: 'Ausblenden',
    missingFamilyType: 'ohne Familien- und Typinformation.',
    deviceOnlyMode: 'Nur-Gerät-Modus',
    plantsUsed: 'Pflanzen verwendet',
    signInGoogleSync: 'Mit Google anmelden zum Synchronisieren',
    connectGoogleDrive: 'Google Drive Verbinden',
    connectDriveDesc: 'Ihre Pflanzen und Fotos werden sicher in Ihrem Google Drive gespeichert. Dies hält Ihre Daten privat und geräteübergreifend synchronisiert.',
    deletePlant: 'Pflanze Löschen',
    deleteConfirmLocal: 'Sind Sie sicher, dass Sie diese Pflanze löschen möchten? Sie wird dauerhaft von Ihrem Gerät entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
    deleteConfirmDrive: 'Sind Sie sicher, dass Sie diese Pflanze löschen möchten? Sie und ihr Foto werden dauerhaft aus Ihrem Google Drive entfernt. Diese Aktion kann nicht rückgängig gemacht werden.',
    exitLocalMode: 'Lokalen Modus Beenden',
    logoutTitle: 'Abmelden',
    logoutConfirmLocal: 'Ihre Pflanzen sind auf diesem Gerät gespeichert und werden noch da sein, wenn Sie zurückkehren. Sie können sich später mit Google anmelden, um Ihre Daten in der Cloud zu synchronisieren.',
    logoutConfirmDrive: 'Sind Sie sicher, dass Sie sich abmelden möchten? Sie müssen sich erneut anmelden, um auf Ihre Pflanzen zuzugreifen.',
    exit: 'Beenden',
    tryDifferentSearch: 'Versuchen Sie einen anderen Suchbegriff',
    noPlantsInstruction: 'Um Ihre Pflanzenbibliothek zu sehen, fügen Sie Ihre erste Pflanze über den orangefarbenen Knopf unten rechts hinzu.',
    addNewPlant: 'Eine neue Pflanze hinzufügen',
    normalCards: 'Normale Karten',
    compactCards: 'Kompakte Karten',
    listViewLabel: 'Listenansicht',
    unnamedPlant: 'Unbenannte Pflanze',
    skipToLibrary: 'Zur Pflanzenbibliothek springen',
    saving: 'Speichern...',
    viewDetails: 'Details anzeigen',
    deleteThisPlant: 'Diese Pflanze löschen?',
    loginSubtitle1: 'Ihr persönlicher Begleiter für die Pflanzenpflege.',
    loginSubtitle2: 'Verfolgen, identifizieren und pflegen Sie Ihre grünen Freunde.',
    getStarted: 'Loslegen',
    loginSignInDesc: 'Melden Sie sich mit Google an, um Ihre Pflanzen geräteübergreifend zu synchronisieren',
    continueWithGoogle: 'Weiter mit Google',
    or: 'oder',
    idRatherNot: 'Lieber nicht',
    onDeviceStorage: 'Gerätespeicher (ohne Anmeldung)',
    acknowledgeEach: 'Bitte bestätigen Sie jeden Punkt, bevor Sie fortfahren:',
    continueToLocalMode: 'Im lokalen Modus fortfahren',
    acknowledgeAll: 'Alle bestätigen',
    aboutAndInstructions: 'Über uns & Anleitung',
    termsOfService: 'Nutzungsbedingungen',
    privacyPolicy: 'Datenschutzrichtlinie',
    aiIdentify: 'KI-Erkennung',
    cloudSync: 'Cloud-Synchronisation',
    careTips: 'Pflegetipps',
    aiIdentifyDesc: 'Machen Sie ein Foto und unsere KI erkennt Ihre Pflanze sofort',
    cloudSyncDesc: 'Ihre Pflanzenbibliothek wird sicher in Google Drive gespeichert',
    careTipsDesc: 'Erhalten Sie individuelle Pflege-, Licht- und Feuchtigkeitshinweise',
    localWarning1: 'Ihre Pflanzendaten werden <strong>nur auf diesem Gerät</strong> in diesem Browser gespeichert.',
    localWarning2: '<strong>Das Löschen Ihrer Browserdaten löscht dauerhaft alle Ihre Pflanzen.</strong>',
    localWarning3: 'Sie sind auf <strong>100 Pflanzen</strong> beschränkt (oder weniger bei geringem Speicher).',
    localWarning4: 'Ihre Daten werden <strong>nicht synchronisiert</strong> zwischen Geräten.',
    localWarning5: 'Sie können sich später mit Google anmelden, um Ihre Daten in die Cloud zu übertragen.',
    bulkEdit: 'Massenbearbeitung',
    selected: 'ausgewählt',
    selectAll: 'Alle auswählen',
    deselectAll: 'Alle abwählen',
    chooseField: 'Feld wählen',
    bulkEditBarLabel: 'Massenbearbeitung',
    chooseValue: 'Wert wählen',
    enterValue: 'Wert eingeben...',
    applying: 'Wird angewendet...',
    applyToSelected: 'Anwenden',
    exitBulkEdit: 'Massenbearbeitung beenden',
    bulkEditConfirmTitle: 'Massenbearbeitung bestätigen',
    bulkEditConfirmDesc: '{field} auf "{value}" für {count} ausgewählte Pflanze(n) aktualisieren?',
    applyChanges: 'Änderungen anwenden',
    bulkUpdateSuccess: '{count} Pflanze(n) erfolgreich aktualisiert',
    bulkUpdateFailed: 'Massenaktualisierung fehlgeschlagen',
    deleteSelected: 'Auswahl löschen',
    bulkDeleteConfirmTitle: 'Massenlöschung bestätigen',
    bulkDeleteConfirmDesc: '{count} ausgewählte Pflanze(n) dauerhaft löschen? Dies kann nicht rückgängig gemacht werden.',
    bulkDeleteSuccess: '{count} Pflanze(n) erfolgreich gelöscht',
    bulkDeleteFailed: 'Massenlöschung fehlgeschlagen',
  },
  pt: {
    appName: 'Meu Inventário Pessoal de Plantas',
    appTagline: 'Seu companheiro pessoal de cuidados com plantas.',
    appTagline2: 'Rastreie, identifique e cuide de seus amigos verdes.',
    getStarted: 'Começar',
    signInPrompt: 'Faça login com o Google para sincronizar suas plantas entre dispositivos',
    continueWithGoogle: 'Continuar com o Google',
    or: 'ou',
    localModeButton: 'Prefiro não',
    localWarningTitle: 'Antes de continuar sem uma conta:',
    continueLocalMode: 'Continuar no modo local',
    cancelLocalMode: 'Cancelar',
    myPlants: 'Minhas Plantas',
    searchPlants: 'Pesquisar plantas...',
    noPlants: 'Nenhuma planta ainda',
    noPlantsDesc: 'Toque no botão + para adicionar sua primeira planta!',
    noResults: 'Nenhuma planta corresponde à sua pesquisa',
    incomplete: 'Incompleto',
    showing: 'Mostrando',
    of: 'de',
    plants: 'plantas',
    plant: 'planta',
    addPlant: 'Adicionar Planta',
    edit: 'Editar',
    editPlant: 'Editar Planta',
    addPhoto: 'Adicionar Foto',
    replacePhoto: 'Substituir Foto',
    photoUpdated: 'Foto atualizada',
    photoAdded: 'Foto adicionada',
    photoReplaced: 'Foto substituída',
    photoUpdateFailed: 'Falha ao atualizar a foto',
    batchAdd: 'Adicionar em Lote',
    fromCamera: 'Da Câmera',
    mergeIntoAnother: "Mesclar com outra planta",
    mergeDialogTitle: "Mesclar estas duas plantas",
    mergeDialogBlurb: "A MANTIDA permanece na sua biblioteca e absorve tudo da outra planta. Escolha qual valor vence em cada campo. As fotos se combinam até o máximo de 5.",
    mergeDialogBlurbV2: "Confirme se os nomes comum e científico coincidem, escolha quais fotos manter e selecione uma capa. A outra planta será absorvida.",
    mergeKeeper: "Mantida (permanece)",
    mergeAbsorbedTitle: "Absorvida (excluída)",
    mergeAbsorbed: "Absorvida",
    mergeKeepThis: "Mantida",
    mergePhotos: "foto(s)",
    mergeConfirm: "Mesclar plantas",
    mergeInProgress: "Mesclando…",
    mergeFailed: "Falha ao mesclar",
    mergeSuccess: "Plantas mescladas.",
    mergeSuccessWithDrop: "Mescladas. {n} foto(s) extra descartada(s) (máx. 5).",
    mergeSameError: "Não é possível mesclar uma planta consigo mesma.",
    mergeDiffHeader: "{n} campo(s) de cuidados diferem — escolha um",
    mergeNoDiff: "As duas plantas têm informações de cuidados idênticas — nada a reconciliar.",
    mergePhotoWarning: "⚠ {n} foto(s) extra serão descartada(s) (máx. 5 por planta).",
    mergeEmpty: "—",
    mergeAction: "Mesclar",
    mergePickerTitle: "Mesclar com outra planta",
    mergePickerBlurb: "Escolha a planta que deve permanecer (a Mantida). {name} será absorvida por ela.",
    mergePickerSearch: "Buscar por nome…",
    mergePickerSuggested: "Prováveis duplicatas",
    mergePickerEmpty: "Nenhuma outra planta corresponde.",
    mergeSelected: "Mesclar selecionadas",
    mergeRequiresTwo: "Selecione exatamente 2 plantas para mesclar",
    mergePlantsNotFound: "Plantas selecionadas não encontradas",
    duplicateBadge: "Duplicata?",
    duplicateBannerBody: "Duas entradas compartilham o nome \"{name}\". Mesclar?",
    fromGallery: 'Da Galeria',
    enterManually: 'Inserir manualmente sem foto',
    doneCropping: 'Recorte Concluído',
    rotate: 'Girar',
    cancel: 'Cancelar',
    skip: 'Pular',
    savePlant: 'Salvar Planta',
    saveAndNext: 'Salvar e Próxima',
    completeLater: 'Completar Depois',
    delete: 'Excluir',
    deleting: 'Excluindo...',
    undoChanges: 'Desfazer alterações',
    cropInstructions: 'Como recortar:',
    cropDesc: 'Clique e arraste em qualquer lugar da imagem para desenhar uma área de recorte. Arraste os cantos ou bordas para redimensionar. Clique em "Recorte Concluído" quando estiver pronto, ou pule para usar a imagem completa.',
    identifyingPlant: 'Identificando planta...',
    looksCorrect: 'Parece Correto',
    recrop: 'Recortar Novamente',
    notRight: 'Não está certo',
    aiThinksThisIs: 'A IA acha que é:',
    wrongEnterCorrectName: 'Errado? Digite o nome correto:',
    pleaseEnterName: 'Por favor, digite um nome',
    aiAutoFill: 'Preencher com IA',
    aiAutoFillHint: 'Digite um nome acima e clique para preencher automaticamente os detalhes de cuidado com IA.',
    addNewPlantTitle: 'Adicionar Nova Planta',
    cropAndRotate: 'Recortar e Girar Foto',
    aiIdentificationTitle: 'Identificação IA',
    plantDetailsTitle: 'Detalhes da Planta',
    allDone: 'Tudo Pronto!',
    processedPlants: '{count} planta(s) processada(s):',
    duplicateFound: 'Duplicata Encontrada',
    youAlreadyHave: 'Você já tem "{name}" na sua biblioteca.',
    replaceExisting: 'Substituir existente por esta',
    keepBoth: 'Manter ambas',
    discardThisOne: 'Descartar esta, manter existente',
    photoXOfY: 'Foto {current} de {total}',
    skippedLabel: '(pulada)',
    returningToSkipped: 'Retornando às fotos puladas...',
    savedAsIncompleteNext: 'Salva como incompleta. Avançando...',
    savedAsIncompleteLater: 'Salva como incompleta. Você pode terminá-la depois pela biblioteca.',
    keptExistingNext: 'Mantida a existente. Avançando para a próxima foto...',
    keptExistingPlant: 'Planta existente mantida.',
    skippedWillReturn: 'Pulada — voltaremos a ela mais tarde',
    removeThisPhoto: 'Remover esta foto',
    removePhotoTitle: 'Remover esta foto?',
    removePhotoDesc: 'Esta foto será descartada e não será adicionada. As outras fotos deste lote permanecem na fila.',
    removePhotoConfirm: 'Remover foto',
    photoRemovedWithCount: 'Foto removida — restam {n}',
    photoRemoved: 'Foto removida',
    photoRestored: 'Foto restaurada',
    photoDupLibrary: 'Esta mesma foto já está na sua biblioteca como "{name}". Você pode adicioná-la mesmo assim ou removê-la.',
    photoDupBatch: 'Você já adicionou esta foto antes neste lote. Você pode adicioná-la mesmo assim ou removê-la.',
    anotherPlant: 'outra planta',
    draftDiscarded: 'Rascunho descartado',
    draftRestored: 'Rascunho restaurado',
    aiDisclaimer: 'Os detalhes de cuidados são gerados por IA (Google Gemini) e podem não ser precisos. Edite qualquer campo conforme necessário — este é seu inventário pessoal.',
    aiDisclaimerDetail: 'Os detalhes de cuidados são gerados por IA usando Google Gemini e podem conter erros. Pesquise por conta própria se a precisão científica for importante.',
    commonName: 'Nome Comum',
    scientificName: 'Nome Científico',
    watering: 'Rega',
    light: 'Luz',
    humidity: 'Umidade',
    temperature: 'Temperatura',
    toxicity: 'Toxicidade',
    growthRate: 'Taxa de Crescimento',
    blooming: 'Floração',
    bloomSeason: 'Estação de floração',
    bloomDuration: 'Duração da floração',
    bloomsIndoors: 'Floresce em interior?',
    bloomTips: 'Dicas de floração',
    toxicityNotes: 'Notas de toxicidade',
    dormancyNotes: 'Notas de dormência',
    bloomLasts: 'Dura',
    bloomNotIndoors: 'Não floresce em interior',
    bloomRarelyIndoors: 'Raramente floresce em interior',
    dormancy: 'Dormência',
    dormantNow: 'Em dormência',
    needsDormancy: 'Precisa de dormência',
    dormancyBannerOne: '1 planta está em dormência este mês.',
    dormancyBannerMany: '{count} plantas estão em dormência este mês.',
    dormancyBannerAction: 'Mostrar',
    backfillPromptOne: 'Faltam detalhes de cuidado em 1 planta.',
    backfillPromptMany: 'Faltam detalhes de cuidado em {count} plantas.',
    backfillPromptAction: 'Preencher →',
    iconLegend: 'Legenda dos ícones',
    show: 'Mostrar',
    hide: 'Ocultar',
    legendCareSection: 'Detalhes de cuidado',
    legendLibrarySection: 'Controles da biblioteca',
    legendFamily: 'Família botânica (por ex. Araceae, Cactaceae).',
    legendPlantType: 'Forma de crescimento: suculenta, trepadeira, perene herbácea, etc.',
    legendWatering: 'Com que frequência e quanta água esta planta precisa.',
    legendLight: 'Nível de luz preferido, de pouca luz a sol pleno.',
    legendHumidity: 'Faixa de umidade em que a planta se sente confortável.',
    legendTemperature: 'Faixa de temperatura ideal em °F e °C.',
    legendToxicity: 'Se é tóxica para animais, humanos ou répteis.',
    legendEnvironment: 'Ambiente doméstico normal, terrário preferido ou terrário obrigatório.',
    legendGrowthRate: 'Crescimento lento, moderado ou rápido.',
    legendDormancy: 'Período de repouso no outono/inverno — queda de folhas ou crescimento mais lento são normais.',
    aiCareNote: 'Nota da IA',
    legendAiNote: 'Informações geradas por IA — confirme em fontes confiáveis.',
    legendIncomplete: 'Completar depois',
    legendIncompleteHint: 'Planta salva mas sem fotos ou detalhes de cuidado.',
    legendPhoto: 'Adicionar / substituir foto',
    legendPhotoHint: 'Até 5 fotos por planta.',
    legendArchive: 'Arquivar',
    legendArchiveHint: 'Remove a planta da biblioteca principal sem excluí-la.',
    legendTerrarium: 'Filtro de terrário',
    legendTerrariumHint: 'Mostrar apenas plantas que precisam ou preferem um terrário.',
    legendDormant: 'Filtro de dormência',
    legendDormantHint: 'Mostrar apenas plantas que estão em período de dormência.',
    legendSearchPlaceholder: 'Buscar ícones…',
    legendNoResults: 'Nenhum ícone corresponde à sua busca.',
    environment: 'Ambiente',
    terrariumOnly: 'Plantas de terrário',
    showAllPlants: 'Mostrar todas as plantas',
    readMore: 'Ler mais',
    showLess: 'Mostrar menos',
    lastSyncedLabel: 'Última sincronização',
    refreshNow: 'Atualizar agora',
    refreshSyncing: 'Atualizando\u2026',
    refreshOffline: 'Você está offline — reconecte-se para atualizar.',
    offlineCacheTitle: 'Cache offline',
    offlineCacheBlurb: 'Uma cópia somente leitura da sua biblioteca mantida neste dispositivo para você navegar offline.',
    offlineCacheStats: '{count} {plantWord} \u00b7 {size} \u00b7 salva {when}',
    offlineCacheClear: 'Limpar cache offline',
    offlineCacheCleared: 'Cache offline limpo',
    offlineCacheClearFailed: 'Não foi possível limpar o cache offline',
    pendingSyncPill: '{n} alterações pendentes de sincronização',
    pendingSyncPillOne: '1 alteração pendente de sincronização',
    pendingSyncTitle: 'Alterações aguardando sincronização',
    pendingSyncBlurbOnline: 'Estas alterações estão salvas neste dispositivo e serão sincronizadas automaticamente.',
    pendingSyncBlurbOffline: 'Você está offline. Elas serão sincronizadas assim que você reconectar.',
    pendingSyncRetry: 'Tentar agora',
    pendingSyncSyncing: 'Sincronizando\u2026',
    pendingSyncDiscard: 'Descartar esta alteração',
    pendingSyncDiscardAll: 'Descartar tudo',
    pendingSyncDiscardAllConfirmTitle: 'Descartar todas as alterações pendentes?',
    pendingSyncDiscardAllConfirmBody: 'Isto remove {n} alterações à espera de sincronização e reverte-as neste dispositivo.',
    pendingSyncDiscardAllConfirmBodyOne: 'Isto remove 1 alteração à espera de sincronização e reverte-a neste dispositivo.',
    pendingSyncDiscardAllToast: 'Todas as alterações pendentes foram descartadas',
    aboutTocTitle: 'Nesta página',
    pendingSyncViewDetails: 'Detalhes',
    allChangesSynced: 'Todas as alterações sincronizadas',
    addOfflineNotice: 'Você está offline: novas plantas precisam de conexão. Editar, arquivar e excluir funcionam e sincronizam ao voltar.',
    pendingWaitingFor: 'aguardando {time}',
    syncProgress: '{done} de {total} sincronizados',
    syncHistoryTitle: 'Atividade de sincronização recente',
    syncHistoryClear: 'Limpar',
    syncStatusSynced: 'Sincronizado',
    syncStatusConflict: 'Conflito',
    syncStatusGaveup: 'Falhou',
    syncStatusDiscarded: 'Descartado',
    discardUndo: 'Desfazer',
    changeDiscarded: 'Alteração descartada',
    syncSyncedOne: '1 alteração sincronizada',
    syncSyncedMany: '{n} alterações sincronizadas',
    syncConflictOne: 'Não foi possível sincronizar "{name}": foi alterada ou removida em outro dispositivo.',
    syncConflictMany: '{n} alterações não puderam ser sincronizadas: essas plantas foram alteradas ou removidas em outro dispositivo.',
    syncGaveupOne: 'Desistimos de sincronizar "{name}" após várias tentativas: refaça, por favor.',
    syncGaveupMany: '{n} alterações não puderam ser salvas após várias tentativas e foram descartadas.',
    syncRetryOne: '1 alteração não pôde ser sincronizada: tentaremos novamente',
    syncRetryMany: '{n} alterações não puderam ser sincronizadas: tentaremos novamente',
    offlineHelpTitle: 'Offline e sincronização',
    offlineHelpBody: 'Offline você pode navegar e editar, arquivar ou excluir plantas — essas alterações entram na fila e sincronizam ao reconectar. Adicionar uma planta nova precisa de conexão.',
    offlineHelpLearnMore: 'Saiba mais',
    aboutSharingTitle: 'Compartilhar suas plantas',
    aboutSharingBody: 'Compartilhe uma única planta como imagem rica, ou toda a sua biblioteca como PDF — visão geral (fotos + nomes), em detalhe completo (uma página por planta) ou só nomes. Cada PDF inclui um QR code que pode ser lido, um link e sua nota de boas-vindas. Quem recebe abre uma visão \u201cgrow-along\u201d somente leitura; nada na sua biblioteca muda e não é possível editá-la.',
    savedOfflineToast: 'Salvo offline — sincroniza ao reconectar',
    offlineWriteBlocked: 'Você está offline — reconecte-se para salvar as alterações.',
    done: 'Entendi',
    pendingOpEdit: 'Editar \u201c{name}\u201d',
    pendingOpArchive: 'Arquivar \u201c{name}\u201d',
    pendingOpDelete: 'Excluir \u201c{name}\u201d',
    pendingOpBulkUpdate: 'Atualizar {count} {plantWord}',
    pendingOpBulkDelete: 'Excluir {count} {plantWord}',
    dateAdded: 'Data de Adição',
    addedOn: 'Adicionado',
    family: 'Família',
    plantType: 'Tipo',
    careDetails: 'Detalhes de Cuidado',
    learnMore: 'Saiba mais de fontes confiáveis',
    tapToEnlarge: 'Toque para ampliar',
    translating: 'Traduzindo...',
    retryTranslation: 'Tentar tradução novamente',
    settings: 'Configurações',
    geminiApiKey: 'Chave API Google Gemini',
    photoQuality: 'Qualidade da Foto',
    fontSize: 'Tamanho da Fonte',
    language: 'Idioma',
    languageDesc: 'Define o idioma de exibição do aplicativo. O padrão é Inglês (EUA).',
    saveSettings: 'Salvar Configurações',
    downloadLibrary: 'Baixar biblioteca',
    downloadLibraryDesc: 'CSV é melhor para reimportar em planilhas ou outras ferramentas. PDF fornece uma cópia imprimível formatada com suporte adequado para nomes de plantas não-latinos.',
    download: 'Baixar',
    downloading: 'Baixando…',
    sharePlants: 'Compartilhar',
    preloadPhotos: 'Pré-carregar todas as fotos',
    photosOnDevice: 'Suas fotos já estão neste dispositivo',
    noPhotosToPreload: 'Nenhuma foto para pré-carregar',
    preloadingPhotos: 'Pré-carregando fotos…',
    photosReady: 'Fotos prontas',
    couldNotLoad: 'indisponíveis',
    photoReadFailed: 'Não foi possível ler essa foto — selecione-a novamente',
    aboutAndInstructions: 'Sobre e Instruções',
    termsOfService: 'Termos de Serviço',
    privacyPolicy: 'Política de Privacidade',
    backToTop: 'Voltar ao topo',
    readingProgress: 'Progresso de leitura',
    linkCopied: 'Link copiado',
    copyLinkToSection: 'Copiar link para esta seção',
    copyPlantLink: 'Copiar link de partilha',
    copyLinkFailed: 'Não foi possível copiar o link',
    qrCreateFailed: 'Não foi possível criar o código QR',
    sortNameAsc: 'Nome (A → Z)',
    sortNameDesc: 'Nome (Z → A)',
    thenBy: 'Depois por',
    thenByPlaceholder: 'Depois por…',
    withPhotos: 'Com fotos',
    noPhotos: 'Sem fotos',
    export: 'Exportar CSV',
    signOut: 'Sair',
    back: 'Voltar',
    previous: 'Anterior',
    next: 'Próximo',
    page: 'Página',
    perPage: 'Por página',
    grouped: 'Agrupado',
    by: 'por',
    needsAttention: 'Precisa de Atenção',
    toComplete: 'para completar',
    found: 'Encontrado',
    updateAll: 'Atualizar Todos',
    updating: 'Atualizando...',
    dismiss: 'Dispensar',
    missingFamilyType: 'faltando informações de Família e Tipo.',
    deviceOnlyMode: 'Modo somente dispositivo',
    plantsUsed: 'plantas usadas',
    signInGoogleSync: 'Faça login com o Google para sincronizar',
    connectGoogleDrive: 'Conectar Google Drive',
    connectDriveDesc: 'Suas plantas e fotos serão armazenadas com segurança no seu Google Drive. Isso mantém seus dados privados e sincronizados entre dispositivos.',
    deletePlant: 'Excluir Planta',
    deleteConfirmLocal: 'Tem certeza de que deseja excluir esta planta? Isso a removerá permanentemente do seu dispositivo. Esta ação não pode ser desfeita.',
    deleteConfirmDrive: 'Tem certeza de que deseja excluir esta planta? Isso removerá permanentemente a planta e sua foto do seu Google Drive. Esta ação não pode ser desfeita.',
    exitLocalMode: 'Sair do Modo Local',
    logoutTitle: 'Sair',
    logoutConfirmLocal: 'Suas plantas estão salvas neste dispositivo e ainda estarão aqui quando você voltar. Você pode fazer login com o Google depois para sincronizar seus dados na nuvem.',
    logoutConfirmDrive: 'Tem certeza de que deseja sair? Você precisará fazer login novamente para acessar suas plantas.',
    exit: 'Sair',
    tryDifferentSearch: 'Tente um termo de pesquisa diferente',
    noPlantsInstruction: 'Para ver sua biblioteca de plantas, adicione sua primeira planta usando o botão laranja no canto inferior direito.',
    addNewPlant: 'Adicionar uma nova planta',
    normalCards: 'Cartões normais',
    compactCards: 'Cartões compactos',
    listViewLabel: 'Visualização em lista',
    unnamedPlant: 'Planta Sem Nome',
    skipToLibrary: 'Ir para a biblioteca de plantas',
    saving: 'Salvando...',
    viewDetails: 'Ver detalhes',
    deleteThisPlant: 'Excluir esta planta?',
    loginSubtitle1: 'Seu companheiro pessoal de cuidados com plantas.',
    loginSubtitle2: 'Rastreie, identifique e cuide de seus amigos verdes.',
    loginSignInDesc: 'Faça login com o Google para sincronizar suas plantas entre dispositivos',
    idRatherNot: 'Prefiro não',
    onDeviceStorage: 'Armazenamento no dispositivo (sem login)',
    acknowledgeEach: 'Por favor, confirme cada item antes de continuar:',
    continuing: 'Continuando...',
    continueToLocalMode: 'Continuar no modo local',
    acknowledgeAll: 'Confirmar todos',
    aiIdentify: 'Identificar com IA',
    cloudSync: 'Sincronização na Nuvem',
    careTips: 'Dicas de Cuidado',
    aiIdentifyDesc: 'Tire uma foto e nossa IA identificará sua planta instantaneamente',
    cloudSyncDesc: 'Sua biblioteca de plantas é armazenada com segurança no Google Drive',
    careTipsDesc: 'Obtenha detalhes personalizados de rega, luz e umidade',
    localWarning1: 'Seus dados de plantas serão armazenados <strong>apenas neste dispositivo</strong>, neste navegador.',
    localWarning2: '<strong>Limpar os dados do navegador excluirá permanentemente todas as suas plantas.</strong>',
    localWarning3: 'Você está limitado a <strong>100 plantas</strong> (ou menos se seu dispositivo tiver pouco armazenamento).',
    localWarning4: 'Seus dados <strong>não serão sincronizados</strong> entre dispositivos.',
    localWarning5: 'Você pode fazer login com o Google depois para mover seus dados para a nuvem.',
    bulkEdit: 'Edição em Massa',
    selected: 'selecionados',
    selectAll: 'Selecionar todos',
    deselectAll: 'Desmarcar todos',
    chooseField: 'Escolher campo',
    bulkEditBarLabel: 'Edição em massa',
    chooseValue: 'Escolher valor',
    enterValue: 'Inserir valor...',
    applying: 'Aplicando...',
    applyToSelected: 'Aplicar',
    exitBulkEdit: 'Sair da edição em massa',
    bulkEditConfirmTitle: 'Confirmar Edição em Massa',
    bulkEditConfirmDesc: 'Atualizar {field} para "{value}" para {count} planta(s) selecionada(s)?',
    applyChanges: 'Aplicar Alterações',
    bulkUpdateSuccess: '{count} planta(s) atualizada(s) com sucesso',
    bulkUpdateFailed: 'Falha na atualização em massa',
    deleteSelected: 'Excluir selecionados',
    bulkDeleteConfirmTitle: 'Confirmar exclusão em massa',
    bulkDeleteConfirmDesc: 'Excluir permanentemente {count} planta(s) selecionada(s)? Esta ação não pode ser desfeita.',
    bulkDeleteSuccess: '{count} planta(s) excluída(s) com sucesso',
    bulkDeleteFailed: 'Falha na exclusão em massa',
  },
  ja: {
    appName: '私の植物インベントリ',
    appTagline: 'あなたの植物ケアパートナー。',
    appTagline2: '植物を追跡、識別、育てましょう。',
    getStarted: '始める',
    signInPrompt: 'Googleでサインインして、デバイス間で植物を同期',
    continueWithGoogle: 'Googleで続行',
    or: 'または',
    localModeButton: '結構です',
    localWarningTitle: 'アカウントなしで続行する前に：',
    continueLocalMode: 'ローカルモードで続行',
    cancelLocalMode: 'キャンセル',
    myPlants: 'マイプラント',
    searchPlants: '植物を検索...',
    noPlants: 'まだ植物がありません',
    noPlantsDesc: '+ボタンをタップして最初の植物を追加しましょう！',
    noResults: '検索に一致する植物がありません',
    incomplete: '未完成',
    showing: '表示中',
    of: '/',
    plants: '植物',
    plant: '植物',
    addPlant: '植物を追加',
    editPlant: '植物を編集',
    edit: '編集',
    addPhoto: '写真を追加',
    replacePhoto: '写真を変更',
    photoUpdated: '写真が更新されました',
    photoAdded: '写真が追加されました',
    photoReplaced: '写真が置き換えられました',
    photoUpdateFailed: '写真の更新に失敗しました',
    batchAdd: '一括追加',
    fromCamera: 'カメラから',
    mergeIntoAnother: "別の植物に統合",
    mergeDialogTitle: "この2つの植物を統合",
    mergeDialogBlurb: "「残す方」がライブラリに残り、もう一方の情報を吸収します。各項目でどちらの値を採用するか選んでください。写真は合計5枚まで統合されます。",
    mergeDialogBlurbV2: "一般名と学名が一致していることを確認し、残す写真とカバー写真を選んでください。もう一方の植物は吸収されます。",
    mergeKeeper: "残す方",
    mergeAbsorbedTitle: "吸収される方（削除）",
    mergeAbsorbed: "吸収",
    mergeKeepThis: "残す方",
    mergePhotos: "枚",
    mergeConfirm: "植物を統合",
    mergeInProgress: "統合中…",
    mergeFailed: "統合に失敗",
    mergeSuccess: "植物を統合しました。",
    mergeSuccessWithDrop: "統合しました。{n}枚の追加写真は破棄されました(最大5枚)。",
    mergeSameError: "同じ植物同士は統合できません。",
    mergeDiffHeader: "{n}項目で情報が異なります — 選んでください",
    mergeNoDiff: "2つの植物のケア情報は同じです — 調整の必要はありません。",
    mergePhotoWarning: "⚠ {n}枚の追加写真は破棄されます(1植物あたり最大5枚)。",
    mergeEmpty: "—",
    mergeAction: "統合",
    mergePickerTitle: "別の植物に統合",
    mergePickerBlurb: "残す方の植物を選んでください。{name} はそこに吸収されます。",
    mergePickerSearch: "名前で検索…",
    mergePickerSuggested: "重複の可能性",
    mergePickerEmpty: "他に該当する植物はありません。",
    mergeSelected: "選択を統合",
    mergeRequiresTwo: "統合するには2つの植物を選択してください",
    mergePlantsNotFound: "選択された植物が見つかりません",
    duplicateBadge: "重複?",
    duplicateBannerBody: "2つのエントリが「{name}」という名前を共有しています。統合しますか?",
    fromGallery: 'ギャラリーから',
    enterManually: '写真なしで手動入力',
    doneCropping: 'トリミング完了',
    rotate: '回転',
    cancel: 'キャンセル',
    skip: 'スキップ',
    savePlant: '植物を保存',
    saveAndNext: '保存して次へ',
    completeLater: '後で完成',
    delete: '削除',
    deleting: '削除中...',
    undoChanges: '変更を元に戻す',
    cropInstructions: 'トリミング方法：',
    cropDesc: '画像上でクリック＆ドラッグしてトリミング範囲を描きます。角や端のハンドルをドラッグしてサイズ変更します。準備ができたら「トリミング完了」をクリックするか、スキップして画像全体を使用します。',
    identifyingPlant: '植物を識別中...',
    looksCorrect: '正しいです',
    recrop: '再トリミング',
    notRight: '違います',
    aiThinksThisIs: 'AIの判定:',
    wrongEnterCorrectName: '違いますか？正しい名前を入力:',
    pleaseEnterName: '名前を入力してください',
    aiAutoFill: 'AIで自動入力',
    aiAutoFillHint: '上に植物名を入力し、クリックしてAIでケア情報を自動入力します。',
    addNewPlantTitle: '新しい植物を追加',
    cropAndRotate: '写真のトリミングと回転',
    aiIdentificationTitle: 'AI識別',
    plantDetailsTitle: '植物の詳細',
    allDone: '完了！',
    processedPlants: '{count}個の植物を処理しました:',
    duplicateFound: '重複が見つかりました',
    youAlreadyHave: '「{name}」はすでにライブラリにあります。',
    replaceExisting: '既存のものをこれに置き換える',
    keepBoth: '両方を保持',
    discardThisOne: 'これを破棄し、既存を保持',
    photoXOfY: '写真 {current}/{total}',
    skippedLabel: '(スキップ済み)',
    returningToSkipped: 'スキップした写真に戻ります...',
    savedAsIncompleteNext: '未完了として保存しました。次へ...',
    savedAsIncompleteLater: '未完了として保存しました。後からライブラリで完了できます。',
    keptExistingNext: '既存を保持しました。次の写真へ...',
    keptExistingPlant: '既存の植物を保持しました。',
    skippedWillReturn: 'スキップ — 後で戻ります',
    removeThisPhoto: 'この写真を削除',
    removePhotoTitle: 'この写真を削除しますか？',
    removePhotoDesc: 'この写真は破棄され、追加されません。このバッチの他の写真はキューに残ります。',
    removePhotoConfirm: '写真を削除',
    photoRemovedWithCount: '写真を削除しました — 残り{n}枚',
    photoRemoved: '写真を削除しました',
    photoRestored: '写真を復元しました',
    photoDupLibrary: 'この写真はすでにライブラリに「{name}」として存在します。そのまま追加することも、削除することもできます。',
    photoDupBatch: 'この写真はこのバッチですでに追加済みです。そのまま追加することも、削除することもできます。',
    anotherPlant: '別の植物',
    draftDiscarded: '下書きを破棄しました',
    draftRestored: '下書きを復元しました',
    aiDisclaimer: 'ケアの詳細はAI生成（Google Gemini）であり、正確でない場合があります。必要に応じて編集してください。',
    aiDisclaimerDetail: 'ケアの詳細はGoogle Geminiを使用してAI生成されており、エラーを含む場合があります。科学的正確性が重要な場合は、ご自身で調査してください。',
    commonName: '一般名',
    scientificName: '学名',
    watering: '水やり',
    light: '光',
    humidity: '湿度',
    temperature: '温度',
    toxicity: '毒性',
    growthRate: '成長速度',
    blooming: '開花',
    bloomSeason: '開花時期',
    bloomDuration: '開花期間',
    bloomsIndoors: '室内で開花？',
    bloomTips: '開花のヒント',
    toxicityNotes: '毒性メモ',
    dormancyNotes: '休眠メモ',
    bloomLasts: '継続',
    bloomNotIndoors: '室内では開花しません',
    bloomRarelyIndoors: '室内ではめったに開花しません',
    dormancy: '休眠',
    dormantNow: '休眠中',
    needsDormancy: '休眠が必要',
    dormancyBannerOne: '1 つの植物が今月休眠期に入っています。',
    dormancyBannerMany: '{count} つの植物が今月休眠期に入っています。',
    dormancyBannerAction: '表示',
    backfillPromptOne: '1つの植物にケアの詳細が不足しています。',
    backfillPromptMany: '{count}つの植物にケアの詳細が不足しています。',
    backfillPromptAction: '入力する →',
    iconLegend: 'アイコンの説明',
    show: '表示',
    hide: '隠す',
    legendCareSection: 'ケアの詳細',
    legendLibrarySection: 'ライブラリの操作',
    legendFamily: '植物の科（例：サトイモ科、サボテン科）。',
    legendPlantType: '生育タイプ：多肉植物、つる性、多年草など。',
    legendWatering: '水やりの頻度と量。',
    legendLight: '好む光の強さ（弱光から直射日光まで）。',
    legendHumidity: '植物が快適に育つ湿度の範囲。',
    legendTemperature: '理想的な温度範囲（°F と °C）。',
    legendToxicity: 'ペット、人間、爬虫類に対する毒性。',
    legendEnvironment: '通常の室内、テラリウム推奨、またはテラリウム必須。',
    legendGrowthRate: '成長速度：ゆっくり、普通、または速い。',
    legendDormancy: '秋・冬の休眠期 — 落葉や成長の停滞は正常です。',
    aiCareNote: 'AI メモ',
    legendAiNote: 'AI が生成した情報です — 信頼できる情報源で確認してください。',
    legendIncomplete: '後で仕上げる',
    legendIncompleteHint: '保存済みですが、写真やケア情報が不足しています。',
    legendPhoto: '写真を追加 / 置き換え',
    legendPhotoHint: '1 株につき最大 5 枚の写真を追加できます。',
    legendArchive: 'アーカイブ',
    legendArchiveHint: '削除せずにメインライブラリから外します。',
    legendTerrarium: 'テラリウム フィルター',
    legendTerrariumHint: 'テラリウムが必要または好む植物のみ表示します。',
    legendDormant: '休眠フィルター',
    legendDormantHint: '現在休眠期に入っている植物のみを表示します。',
    legendSearchPlaceholder: 'アイコンを検索…',
    legendNoResults: '一致するアイコンはありません。',
    environment: '生育環境',
    terrariumOnly: 'テラリウム植物',
    showAllPlants: 'すべての植物を表示',
    readMore: 'もっと見る',
    showLess: '折りたたむ',
    lastSyncedLabel: '最終同期',
    refreshNow: '今すぐ更新',
    refreshSyncing: '更新中\u2026',
    refreshOffline: 'オフラインです。更新するには再接続してください。',
    offlineCacheTitle: 'オフラインキャッシュ',
    offlineCacheBlurb: 'オフラインでも閲覧できるよう、この端末に保存されたライブラリの読み取り専用コピーです。',
    offlineCacheStats: '{count}件の植物 \u00b7 {size} \u00b7 保存: {when}',
    offlineCacheClear: 'オフラインキャッシュを消去',
    offlineCacheCleared: 'オフラインキャッシュを消去しました',
    offlineCacheClearFailed: 'オフラインキャッシュを消去できませんでした',
    pendingSyncPill: '{n}件の変更が同期待ちです',
    pendingSyncPillOne: '1件の変更が同期待ちです',
    pendingSyncTitle: '同期待ちの変更',
    pendingSyncBlurbOnline: 'これらの変更はこの端末に保存されており、自動的に同期されます。',
    pendingSyncBlurbOffline: 'オフラインです。再接続するとすぐに同期されます。',
    pendingSyncRetry: '今すぐ再試行',
    pendingSyncSyncing: '同期中\u2026',
    pendingSyncDiscard: 'この変更を破棄',
    pendingSyncDiscardAll: 'すべて破棄',
    pendingSyncDiscardAllConfirmTitle: '保留中の変更をすべて破棄しますか？',
    pendingSyncDiscardAllConfirmBody: '同期待ちの{n}件の変更を削除し、この端末で元に戻します。',
    pendingSyncDiscardAllConfirmBodyOne: '同期待ちの1件の変更を削除し、この端末で元に戻します。',
    pendingSyncDiscardAllToast: '保留中の変更をすべて破棄しました',
    aboutTocTitle: 'このページの内容',
    pendingSyncViewDetails: '詳細',
    allChangesSynced: 'すべての変更を同期しました',
    addOfflineNotice: 'オフラインです。新しい植物の追加には接続が必要です。編集・アーカイブ・削除は可能で、復帰時に同期されます。',
    pendingWaitingFor: '待機中 {time}',
    syncProgress: '{total}件中{done}件同期',
    syncHistoryTitle: '最近の同期アクティビティ',
    syncHistoryClear: 'クリア',
    syncStatusSynced: '同期済み',
    syncStatusConflict: '競合',
    syncStatusGaveup: '失敗',
    syncStatusDiscarded: '破棄',
    discardUndo: '元に戻す',
    changeDiscarded: '変更を破棄しました',
    syncSyncedOne: '1件の変更を同期しました',
    syncSyncedMany: '{n}件の変更を同期しました',
    syncConflictOne: '「{name}」を同期できませんでした。別の端末で変更または削除されました。',
    syncConflictMany: '{n}件の変更を同期できませんでした。これらの植物は別の端末で変更または削除されました。',
    syncGaveupOne: '「{name}」の同期を数回試みましたが断念しました。もう一度お試しください。',
    syncGaveupMany: '{n}件の変更を数回試みても保存できず、破棄されました。',
    syncRetryOne: '1件の変更を同期できませんでした。再試行します',
    syncRetryMany: '{n}件の変更を同期できませんでした。再試行します',
    offlineHelpTitle: 'オフラインと同期',
    offlineHelpBody: 'オフラインでも閲覧や、植物の編集・アーカイブ・削除ができます。これらの変更はキューに入り、再接続時に自動で同期されます。新しい植物の追加には接続が必要です。',
    offlineHelpLearnMore: '詳しく見る',
    aboutSharingTitle: '植物を共有する',
    aboutSharingBody: '1つの植物は画像として、ライブラリ全体はPDFとして共有できます — 一覧（写真＋名前）、詳細（1植物1ページ）、名前のみ。各PDFにはスキャンできるQRコード、リンク、ウェルカムメッセージが含まれます。受け取った人は読み取り専用の「grow-along」ビューを開きます。あなたのライブラリは変更されず、編集もできません。',
    savedOfflineToast: 'オフラインで保存しました。再接続時に同期されます',
    offlineWriteBlocked: 'オフラインです。変更を保存するには再接続してください。',
    done: '閉じる',
    pendingOpEdit: '「{name}」を編集',
    pendingOpArchive: '「{name}」をアーカイブ',
    pendingOpDelete: '「{name}」を削除',
    pendingOpBulkUpdate: '{count}件の植物を更新',
    pendingOpBulkDelete: '{count}件の植物を削除',
    dateAdded: '追加日',
    addedOn: '追加日',
    family: '科',
    plantType: 'タイプ',
    careDetails: 'ケアの詳細',
    learnMore: '信頼できる情報源で詳しく知る',
    tapToEnlarge: 'タップで拡大',
    translating: '翻訳中...',
    retryTranslation: '翻訳を再試行',
    settings: '設定',
    geminiApiKey: 'Google Gemini APIキー',
    photoQuality: '写真品質',
    fontSize: 'フォントサイズ',
    language: '言語',
    languageDesc: 'アプリの表示言語を設定します。デフォルトは英語（米国）です。',
    saveSettings: '設定を保存',
    downloadLibrary: 'ライブラリをダウンロード',
    downloadLibraryDesc: 'CSV はスプレッドシートなどのツールに再取り込みするのに最適です。PDF は非ラテン文字の植物名にも対応した、印刷可能な整形済みコピーを提供します。',
    download: 'ダウンロード',
    downloading: 'ダウンロード中…',
    sharePlants: '共有',
    preloadPhotos: 'すべての写真を事前読み込み',
    photosOnDevice: '写真はすでにこの端末にあります',
    noPhotosToPreload: '事前読み込みする写真がありません',
    preloadingPhotos: '写真を読み込み中…',
    photosReady: '写真の準備完了',
    couldNotLoad: '利用不可',
    photoReadFailed: 'その写真を読み込めませんでした。もう一度選んでください',
    aboutAndInstructions: '概要と使い方',
    termsOfService: '利用規約',
    privacyPolicy: 'プライバシーポリシー',
    backToTop: 'トップに戻る',
    readingProgress: '読み進み具合',
    linkCopied: 'リンクをコピーしました',
    copyLinkToSection: 'このセクションへのリンクをコピー',
    copyPlantLink: '共有リンクをコピー',
    copyLinkFailed: 'リンクをコピーできませんでした',
    qrCreateFailed: 'QRコードを作成できませんでした',
    sortNameAsc: '名前（A → Z）',
    sortNameDesc: '名前（Z → A）',
    thenBy: '次に',
    thenByPlaceholder: '次に…',
    withPhotos: '写真あり',
    noPhotos: '写真なし',
    export: 'CSVエクスポート',
    signOut: 'サインアウト',
    back: '戻る',
    previous: '前へ',
    next: '次へ',
    page: 'ページ',
    perPage: '表示件数',
    grouped: 'グループ化',
    by: '別',
    needsAttention: '注意が必要',
    toComplete: '完成まで',
    found: '見つかりました',
    updateAll: 'すべて更新',
    updating: '更新中...',
    dismiss: '閉じる',
    missingFamilyType: '科とタイプの情報が不足しています。',
    deviceOnlyMode: 'デバイス専用モード',
    plantsUsed: '植物使用中',
    signInGoogleSync: 'Googleでサインインして同期',
    connectGoogleDrive: 'Google Driveに接続',
    connectDriveDesc: '植物と写真はGoogle Driveに安全に保存されます。データのプライバシーが保たれ、デバイス間で同期されます。',
    deletePlant: '植物を削除',
    deleteConfirmLocal: 'この植物を削除してもよろしいですか？デバイスから完全に削除されます。この操作は元に戻せません。',
    deleteConfirmDrive: 'この植物を削除してもよろしいですか？植物と写真がGoogle Driveから完全に削除されます。この操作は元に戻せません。',
    exitLocalMode: 'ローカルモードを終了',
    logoutTitle: 'ログアウト',
    logoutConfirmLocal: '植物はこのデバイスに保存されており、戻ったときにまだここにあります。後でGoogleでサインインしてデータをクラウドに同期できます。',
    logoutConfirmDrive: 'ログアウトしてもよろしいですか？植物にアクセスするには再度サインインする必要があります。',
    exit: '終了',
    tryDifferentSearch: '別の検索語を試してください',
    noPlantsInstruction: '植物ライブラリを表示するには、右下のオレンジ色のボタンを使って最初の植物を追加してください。',
    addNewPlant: '新しい植物を追加',
    normalCards: '通常カード',
    compactCards: 'コンパクトカード',
    listViewLabel: 'リスト表示',
    unnamedPlant: '名前なしの植物',
    skipToLibrary: '植物ライブラリへスキップ',
    saving: '保存中...',
    viewDetails: '詳細を見る',
    deleteThisPlant: 'この植物を削除しますか？',
    loginSubtitle1: 'あなたの植物ケアパートナー。',
    loginSubtitle2: '植物を追跡、識別、育てましょう。',
    loginSignInDesc: 'Googleでサインインして、デバイス間で植物を同期',
    idRatherNot: '結構です',
    onDeviceStorage: 'デバイス上ストレージ（ログイン不要）',
    acknowledgeEach: '続行する前に各項目を確認してください：',
    continuing: '続行中...',
    continueToLocalMode: 'ローカルモードで続行',
    acknowledgeAll: 'すべて確認',
    aiIdentify: 'AI識別',
    cloudSync: 'クラウド同期',
    careTips: 'ケアのヒント',
    aiIdentifyDesc: '写真を撮るとAIが植物を即座に識別します',
    cloudSyncDesc: '植物ライブラリはGoogleドライブに安全に保存されます',
    careTipsDesc: '水やり、光、湿度のケア情報を取得します',
    localWarning1: '植物データは<strong>このデバイスのみ</strong>、このブラウザに保存されます。',
    localWarning2: '<strong>ブラウザデータを消去すると、すべての植物が完全に削除されます。</strong>',
    localWarning3: '<strong>100植物</strong>に制限されています（デバイスのストレージが少ない場合はそれ以下）。',
    localWarning4: 'データはデバイス間で<strong>同期されません</strong>。',
    localWarning5: '後でGoogleでサインインしてデータをクラウドに移動できます。',
    bulkEdit: '一括編集',
    selected: '選択中',
    selectAll: 'すべて選択',
    deselectAll: 'すべて解除',
    chooseField: 'フィールドを選択',
    bulkEditBarLabel: '一括編集',
    chooseValue: '値を選択',
    enterValue: '値を入力...',
    applying: '適用中...',
    applyToSelected: '適用',
    exitBulkEdit: '一括編集を終了',
    bulkEditConfirmTitle: '一括編集の確認',
    bulkEditConfirmDesc: '{count}個の選択した植物の{field}を「{value}」に更新しますか？',
    applyChanges: '変更を適用',
    bulkUpdateSuccess: '{count}個の植物が正常に更新されました',
    bulkUpdateFailed: '一括更新に失敗しました',
    deleteSelected: '選択を削除',
    bulkDeleteConfirmTitle: '一括削除の確認',
    bulkDeleteConfirmDesc: '選択した{count}個の植物を完全に削除しますか？この操作は元に戻せません。',
    bulkDeleteSuccess: '{count}個の植物が正常に削除されました',
    bulkDeleteFailed: '一括削除に失敗しました',
  },
  ko: {
    appName: '나의 식물 인벤토리',
    appTagline: '당신의 식물 관리 파트너.',
    appTagline2: '식물을 추적하고 식별하고 키우세요.',
    getStarted: '시작하기',
    signInPrompt: 'Google로 로그인하여 기기 간 식물 동기화',
    continueWithGoogle: 'Google로 계속',
    or: '또는',
    localModeButton: '괜찮습니다',
    localWarningTitle: '계정 없이 계속하기 전에:',
    continueLocalMode: '로컬 모드로 계속',
    cancelLocalMode: '취소',
    myPlants: '내 식물',
    searchPlants: '식물 검색...',
    noPlants: '아직 식물이 없습니다',
    noPlantsDesc: '+ 버튼을 눌러 첫 번째 식물을 추가하세요!',
    noResults: '검색과 일치하는 식물이 없습니다',
    incomplete: '미완성',
    showing: '표시 중',
    of: '/',
    plants: '식물',
    plant: '식물',
    addPlant: '식물 추가',
    editPlant: '식물 편집',
    edit: '편집',
    addPhoto: '사진 추가',
    replacePhoto: '사진 교체',
    photoUpdated: '사진이 업데이트되었습니다',
    photoAdded: '사진이 추가되었습니다',
    photoReplaced: '사진이 교체되었습니다',
    photoUpdateFailed: '사진 업데이트 실패',
    batchAdd: '일괄 추가',
    fromCamera: '카메라에서',
    mergeIntoAnother: "다른 식물과 병합",
    mergeDialogTitle: "이 두 식물을 병합",
    mergeDialogBlurb: "\"유지 대상\"이 라이브러리에 남고 다른 식물의 모든 것을 흡수합니다. 각 필드에서 어느 값이 이길지 선택하세요. 사진은 최대 5장까지 결합됩니다.",
    mergeDialogBlurbV2: "일반명과 학명이 일치하는지 확인하고, 남길 사진과 커버 사진을 선택하세요. 다른 식물은 흡수됩니다.",
    mergeKeeper: "유지 대상 (남음)",
    mergeAbsorbedTitle: "흡수됨 (삭제됨)",
    mergeAbsorbed: "흡수됨",
    mergeKeepThis: "유지",
    mergePhotos: "장",
    mergeConfirm: "식물 병합",
    mergeInProgress: "병합 중…",
    mergeFailed: "병합 실패",
    mergeSuccess: "식물이 병합되었습니다.",
    mergeSuccessWithDrop: "병합됨. 추가 사진 {n}장이 폐기되었습니다 (최대 5장).",
    mergeSameError: "동일한 식물끼리는 병합할 수 없습니다.",
    mergeDiffHeader: "관리 필드 {n}개가 다릅니다 — 하나 선택",
    mergeNoDiff: "두 식물의 관리 정보가 동일합니다 — 조정할 것이 없습니다.",
    mergePhotoWarning: "⚠ 추가 사진 {n}장이 폐기됩니다 (식물당 최대 5장).",
    mergeEmpty: "—",
    mergeAction: "병합",
    mergePickerTitle: "다른 식물과 병합",
    mergePickerBlurb: "유지할 식물을 선택하세요. {name}이(가) 그 식물에 흡수됩니다.",
    mergePickerSearch: "이름으로 검색…",
    mergePickerSuggested: "가능성 있는 중복",
    mergePickerEmpty: "일치하는 다른 식물이 없습니다.",
    mergeSelected: "선택 항목 병합",
    mergeRequiresTwo: "병합하려면 정확히 2개의 식물을 선택하세요",
    mergePlantsNotFound: "선택한 식물을 찾을 수 없습니다",
    duplicateBadge: "중복?",
    duplicateBannerBody: "두 항목이 \"{name}\"이라는 이름을 공유합니다. 병합할까요?",
    fromGallery: '갤러리에서',
    enterManually: '사진 없이 수동 입력',
    doneCropping: '자르기 완료',
    rotate: '회전',
    cancel: '취소',
    skip: '건너뛰기',
    savePlant: '식물 저장',
    saveAndNext: '저장 후 다음',
    completeLater: '나중에 완성',
    delete: '삭제',
    deleting: '삭제 중...',
    undoChanges: '변경 취소',
    cropInstructions: '자르기 방법:',
    cropDesc: '이미지 위에서 클릭하고 드래그하여 자르기 영역을 그립니다. 모서리나 가장자리 핸들을 드래그하여 크기를 조정합니다. 준비가 되면 "자르기 완료"를 클릭하거나 건너뛰어 전체 이미지를 사용합니다.',
    identifyingPlant: '식물 식별 중...',
    looksCorrect: '맞습니다',
    recrop: '다시 자르기',
    notRight: '틀렸습니다',
    aiThinksThisIs: 'AI가 판단한 결과:',
    wrongEnterCorrectName: '틀렸나요? 올바른 이름을 입력하세요:',
    pleaseEnterName: '이름을 입력하세요',
    aiAutoFill: 'AI로 자동 입력',
    aiAutoFillHint: '위에 식물 이름을 입력한 후 클릭하면 AI가 관리 정보를 자동으로 채웁니다.',
    addNewPlantTitle: '새 식물 추가',
    cropAndRotate: '사진 자르기 및 회전',
    aiIdentificationTitle: 'AI 식별',
    plantDetailsTitle: '식물 상세정보',
    allDone: '모두 완료!',
    processedPlants: '{count}개의 식물을 처리했습니다:',
    duplicateFound: '중복 발견',
    youAlreadyHave: '"{name}"이(가) 이미 라이브러리에 있습니다.',
    replaceExisting: '기존 것을 이것으로 교체',
    keepBoth: '둘 다 유지',
    discardThisOne: '이것을 버리고 기존 것 유지',
    photoXOfY: '사진 {current}/{total}',
    skippedLabel: '(건너뜀)',
    returningToSkipped: '건너뛴 사진으로 돌아갑니다...',
    savedAsIncompleteNext: '미완료로 저장했습니다. 다음으로...',
    savedAsIncompleteLater: '미완료로 저장했습니다. 나중에 라이브러리에서 완료할 수 있습니다.',
    keptExistingNext: '기존 것을 유지했습니다. 다음 사진으로...',
    keptExistingPlant: '기존 식물을 유지했습니다.',
    skippedWillReturn: '건너뜀 — 나중에 돌아옵니다',
    removeThisPhoto: '이 사진 제거',
    removePhotoTitle: '이 사진을 제거할까요?',
    removePhotoDesc: '이 사진은 삭제되어 추가되지 않습니다. 이 배치의 다른 사진은 대기열에 남아 있습니다.',
    removePhotoConfirm: '사진 제거',
    photoRemovedWithCount: '사진 제거됨 — {n}장 남음',
    photoRemoved: '사진 제거됨',
    photoRestored: '사진 복원됨',
    photoDupLibrary: '이 사진은 이미 라이브러리에 "{name}"(으)로 있습니다. 그래도 추가하거나 제거할 수 있습니다.',
    photoDupBatch: '이 사진은 이 배치에서 이미 추가했습니다. 그래도 추가하거나 제거할 수 있습니다.',
    anotherPlant: '다른 식물',
    draftDiscarded: '초안 삭제됨',
    draftRestored: '초안 복원됨',
    aiDisclaimer: '관리 정보는 AI 생성(Google Gemini)이며 정확하지 않을 수 있습니다. 필요에 따라 편집하세요.',
    aiDisclaimerDetail: '관리 정보는 Google Gemini를 사용하여 AI 생성되었으며 오류가 있을 수 있습니다. 과학적 정확성이 중요한 경우 직접 조사하세요.',
    commonName: '일반명',
    scientificName: '학명',
    watering: '물주기',
    light: '빛',
    humidity: '습도',
    temperature: '온도',
    toxicity: '독성',
    growthRate: '성장 속도',
    blooming: '개화',
    bloomSeason: '개화 시기',
    bloomDuration: '개화 기간',
    bloomsIndoors: '실내에서 개화?',
    bloomTips: '개화 팁',
    toxicityNotes: '독성 메모',
    dormancyNotes: '휴면 메모',
    bloomLasts: '지속',
    bloomNotIndoors: '실내에서 개화하지 않음',
    bloomRarelyIndoors: '실내에서 거의 개화하지 않음',
    dormancy: '휴면',
    dormantNow: '휴면 중',
    needsDormancy: '휴면 필요',
    dormancyBannerOne: '이번 달 휴면 상태인 식물이 1개 있습니다.',
    dormancyBannerMany: '이번 달 휴면 상태인 식물이 {count}개 있습니다.',
    dormancyBannerAction: '보기',
    iconLegend: '아이콘 설명',
    show: '보기',
    hide: '숨기기',
    legendCareSection: '관리 정보',
    legendLibrarySection: '라이브러리 조작',
    legendFamily: '식물의 과 (예: 천남성과, 선인장과).',
    legendPlantType: '생장 형태: 다육식물, 덩굴, 여러해살이 등.',
    legendWatering: '물 주는 빈도와 양.',
    legendLight: '선호하는 광량 (약한 빛부터 강한 햇빛까지).',
    legendHumidity: '식물이 잘 자라는 습도 범위.',
    legendTemperature: '이상적인 온도 범위 (°F 및 °C).',
    legendToxicity: '반려동물·사람·파충류에 대한 독성 여부.',
    legendEnvironment: '일반 실내, 테라리움 권장 또는 테라리움 필수.',
    legendGrowthRate: '느림, 보통, 또는 빠른 생장.',
    legendDormancy: '가을·겨울 휴면기 — 잎이 떨어지거나 생장이 느려지는 것은 정상입니다.',
    aiCareNote: 'AI 참고',
    legendAiNote: 'AI가 생성한 정보 — 신뢰할 수 있는 자료로 확인하세요.',
    legendIncomplete: '나중에 완성',
    legendIncompleteHint: '저장되었지만 사진 또는 관리 정보가 없습니다.',
    legendPhoto: '사진 추가 / 교체',
    legendPhotoHint: '식물당 사진을 최대 5장 첨부할 수 있습니다.',
    legendArchive: '보관',
    legendArchiveHint: '삭제하지 않고 메인 라이브러리에서 이동합니다.',
    legendTerrarium: '테라리움 필터',
    legendTerrariumHint: '테라리움을 필요로 하거나 선호하는 식물만 표시합니다.',
    legendDormant: '휴면 필터',
    legendDormantHint: '현재 휴면 상태인 식물만 표시합니다.',
    legendSearchPlaceholder: '아이콘 검색…',
    legendNoResults: '검색어와 일치하는 아이콘이 없습니다.',
    environment: '환경',
    terrariumOnly: '테라리움 식물',
    showAllPlants: '모든 식물 보기',
    readMore: '더 보기',
    showLess: '간략히 보기',
    lastSyncedLabel: '마지막 동기화',
    refreshNow: '지금 새로고침',
    refreshSyncing: '새로고침 중\u2026',
    refreshOffline: '오프라인 상태입니다. 새로고침하려면 다시 연결하세요.',
    offlineCacheTitle: '오프라인 캐시',
    offlineCacheBlurb: '오프라인에서도 둘러볼 수 있도록 이 기기에 저장된 라이브러리의 읽기 전용 사본입니다.',
    offlineCacheStats: '식물 {count}개 \u00b7 {size} \u00b7 저장됨 {when}',
    offlineCacheClear: '오프라인 캐시 지우기',
    offlineCacheCleared: '오프라인 캐시를 지웠습니다',
    offlineCacheClearFailed: '오프라인 캐시를 지울 수 없습니다',
    pendingSyncPill: '동기화 대기 중인 변경 {n}건',
    pendingSyncPillOne: '동기화 대기 중인 변경 1건',
    pendingSyncTitle: '동기화 대기 중인 변경',
    pendingSyncBlurbOnline: '이 변경 사항은 이 기기에 저장되어 있으며 자동으로 동기화됩니다.',
    pendingSyncBlurbOffline: '오프라인 상태입니다. 다시 연결되면 바로 동기화됩니다.',
    pendingSyncRetry: '지금 다시 시도',
    pendingSyncSyncing: '동기화 중\u2026',
    pendingSyncDiscard: '이 변경 삭제',
    pendingSyncDiscardAll: '모두 삭제',
    pendingSyncDiscardAllConfirmTitle: '대기 중인 변경 사항을 모두 삭제할까요?',
    pendingSyncDiscardAllConfirmBody: '동기화 대기 중인 변경 {n}건을 제거하고 이 기기에서 되돌립니다.',
    pendingSyncDiscardAllConfirmBodyOne: '동기화 대기 중인 변경 1건을 제거하고 이 기기에서 되돌립니다.',
    pendingSyncDiscardAllToast: '대기 중인 변경 사항을 모두 삭제했습니다',
    aboutTocTitle: '이 페이지에서',
    pendingSyncViewDetails: '자세히',
    allChangesSynced: '모든 변경이 동기화됨',
    addOfflineNotice: '오프라인 상태입니다. 새 식물 추가에는 연결이 필요합니다. 편집·보관·삭제는 가능하며 복귀 시 동기화됩니다.',
    pendingWaitingFor: '대기 중 {time}',
    syncProgress: '{total}개 중 {done}개 동기화',
    syncHistoryTitle: '최근 동기화 활동',
    syncHistoryClear: '지우기',
    syncStatusSynced: '동기화됨',
    syncStatusConflict: '충돌',
    syncStatusGaveup: '실패',
    syncStatusDiscarded: '삭제됨',
    discardUndo: '실행 취소',
    changeDiscarded: '변경을 취소했습니다',
    syncSyncedOne: '변경 1건을 동기화했습니다',
    syncSyncedMany: '변경 {n}건을 동기화했습니다',
    syncConflictOne: '"{name}"을(를) 동기화할 수 없습니다. 다른 기기에서 변경되거나 삭제되었습니다.',
    syncConflictMany: '변경 {n}건을 동기화할 수 없습니다. 해당 식물이 다른 기기에서 변경되거나 삭제되었습니다.',
    syncGaveupOne: '여러 번 시도했지만 "{name}" 동기화를 중단했습니다. 다시 시도해 주세요.',
    syncGaveupMany: '변경 {n}건을 여러 번 시도했지만 저장하지 못해 삭제했습니다.',
    syncRetryOne: '변경 1건을 동기화하지 못했습니다. 다시 시도합니다',
    syncRetryMany: '변경 {n}건을 동기화하지 못했습니다. 다시 시도합니다',
    offlineHelpTitle: '오프라인 및 동기화',
    offlineHelpBody: '오프라인에서도 식물을 둘러보고 편집·보관·삭제할 수 있습니다. 이러한 변경은 대기열에 추가되어 다시 연결되면 자동으로 동기화됩니다. 새 식물 추가에는 연결이 필요합니다.',
    offlineHelpLearnMore: '자세히 보기',
    aboutSharingTitle: '식물 공유하기',
    aboutSharingBody: '식물 하나는 이미지로, 전체 라이브러리는 PDF로 공유하세요 — 한눈에 보기(사진+이름), 상세 정보(식물당 한 페이지), 이름만. 모든 PDF에는 스캔 가능한 QR 코드, 링크, 환영 메시지가 포함됩니다. 받는 사람은 읽기 전용 \u201cgrow-along\u201d 화면을 엽니다. 내 라이브러리는 변경되지 않으며 편집할 수 없습니다.',
    savedOfflineToast: '오프라인으로 저장됨 — 다시 연결되면 동기화됩니다',
    offlineWriteBlocked: '오프라인 상태입니다. 변경을 저장하려면 다시 연결하세요.',
    done: '확인',
    pendingOpEdit: '\u201c{name}\u201d 편집',
    pendingOpArchive: '\u201c{name}\u201d 보관',
    pendingOpDelete: '\u201c{name}\u201d 삭제',
    pendingOpBulkUpdate: '식물 {count}개 업데이트',
    pendingOpBulkDelete: '식물 {count}개 삭제',
    dateAdded: '추가 날짜',
    addedOn: '추가됨',
    family: '과',
    plantType: '유형',
    careDetails: '관리 정보',
    learnMore: '신뢰할 수 있는 출처에서 자세히 알아보기',
    tapToEnlarge: '탭하여 확대',
    translating: '번역 중...',
    retryTranslation: '번역 재시도',
    settings: '설정',
    geminiApiKey: 'Google Gemini API 키',
    photoQuality: '사진 품질',
    fontSize: '글꼴 크기',
    language: '언어',
    languageDesc: '앱의 표시 언어를 설정합니다. 기본값은 영어(미국)입니다.',
    saveSettings: '설정 저장',
    downloadLibrary: '라이브러리 다운로드',
    downloadLibraryDesc: 'CSV는 스프레드시트 등 다른 도구로 다시 가져올 때 가장 적합합니다. PDF는 라틴 문자가 아닌 식물 이름도 올바르게 지원되는 인쇄용 서식이 지정된 사본을 제공합니다.',
    download: '다운로드',
    downloading: '다운로드 중…',
    sharePlants: '공유',
    preloadPhotos: '모든 사진 미리 불러오기',
    photosOnDevice: '사진이 이미 이 기기에 있습니다',
    noPhotosToPreload: '미리 불러올 사진이 없습니다',
    preloadingPhotos: '사진 미리 불러오는 중…',
    photosReady: '사진 준비 완료',
    couldNotLoad: '사용 불가',
    photoReadFailed: '사진을 읽을 수 없습니다 — 다시 선택해 주세요',
    aboutAndInstructions: '소개 및 사용법',
    termsOfService: '서비스 약관',
    privacyPolicy: '개인정보 보호정책',
    backToTop: '맨 위로',
    readingProgress: '읽기 진행률',
    linkCopied: '링크가 복사되었습니다',
    copyLinkToSection: '이 섹션 링크 복사',
    copyPlantLink: '공유 링크 복사',
    copyLinkFailed: '링크를 복사할 수 없습니다',
    qrCreateFailed: 'QR 코드를 만들 수 없습니다',
    sortNameAsc: '이름 (A → Z)',
    sortNameDesc: '이름 (Z → A)',
    thenBy: '다음 기준',
    thenByPlaceholder: '다음 기준…',
    withPhotos: '사진 있음',
    noPhotos: '사진 없음',
    export: 'CSV 내보내기',
    signOut: '로그아웃',
    back: '뒤로',
    previous: '이전',
    next: '다음',
    page: '페이지',
    perPage: '페이지당',
    grouped: '그룹화',
    by: '기준',
    needsAttention: '주의 필요',
    toComplete: '완성까지',
    found: '발견됨',
    updateAll: '모두 업데이트',
    updating: '업데이트 중...',
    dismiss: '닫기',
    missingFamilyType: '과 및 유형 정보가 누락되었습니다.',
    deviceOnlyMode: '기기 전용 모드',
    plantsUsed: '식물 사용 중',
    signInGoogleSync: 'Google로 로그인하여 동기화',
    connectGoogleDrive: 'Google Drive 연결',
    connectDriveDesc: '식물과 사진이 Google Drive에 안전하게 저장됩니다. 데이터가 비공개로 유지되고 기기 간에 동기화됩니다.',
    deletePlant: '식물 삭제',
    deleteConfirmLocal: '이 식물을 삭제하시겠습니까? 기기에서 영구적으로 제거됩니다. 이 작업은 취소할 수 없습니다.',
    deleteConfirmDrive: '이 식물을 삭제하시겠습니까? 식물과 사진이 Google Drive에서 영구적으로 제거됩니다. 이 작업은 취소할 수 없습니다.',
    exitLocalMode: '로컬 모드 종료',
    logoutTitle: '로그아웃',
    logoutConfirmLocal: '식물은 이 기기에 저장되어 있으며 돌아올 때 여전히 여기에 있습니다. 나중에 Google로 로그인하여 데이터를 클라우드에 동기화할 수 있습니다.',
    logoutConfirmDrive: '로그아웃하시겠습니까? 식물에 접근하려면 다시 로그인해야 합니다.',
    exit: '종료',
    tryDifferentSearch: '다른 검색어를 시도해 보세요',
    noPlantsInstruction: '식물 라이브러리를 보려면 오른쪽 하단의 주황색 버튼을 사용하여 첫 번째 식물을 추가하세요.',
    addNewPlant: '새 식물 추가',
    normalCards: '일반 카드',
    compactCards: '컴팩트 카드',
    listViewLabel: '목록 보기',
    unnamedPlant: '이름 없는 식물',
    skipToLibrary: '식물 라이브러리로 이동',
    saving: '저장 중...',
    viewDetails: '상세 보기',
    deleteThisPlant: '이 식물을 삭제하시겠습니까?',
    loginSubtitle1: '당신의 식물 관리 파트너.',
    loginSubtitle2: '식물을 추적하고 식별하고 키우세요.',
    loginSignInDesc: 'Google로 로그인하여 기기 간 식물 동기화',
    idRatherNot: '괜찮습니다',
    onDeviceStorage: '기기 내 저장 (로그인 불필요)',
    acknowledgeEach: '계속하기 전에 각 항목을 확인하세요:',
    continuing: '계속 중...',
    continueToLocalMode: '로컬 모드로 계속',
    acknowledgeAll: '모두 확인',
    aiIdentify: 'AI 식별',
    cloudSync: '클라우드 동기화',
    careTips: '관리 팁',
    aiIdentifyDesc: '사진을 찍으면 AI가 즉시 식물을 식별합니다',
    cloudSyncDesc: '식물 라이브러리가 Google 드라이브에 안전하게 저장됩니다',
    careTipsDesc: '맞춤형 물주기, 빛, 습도 관리 정보를 받아보세요',
    localWarning1: '식물 데이터는 이 브라우저의 <strong>이 기기에만</strong> 저장됩니다.',
    localWarning2: '<strong>브라우저 데이터를 지우면 모든 식물이 영구적으로 삭제됩니다.</strong>',
    localWarning3: '<strong>100개의 식물</strong>로 제한됩니다 (기기 저장 공간이 적으면 더 적음).',
    localWarning4: '데이터는 기기 간에 <strong>동기화되지 않습니다</strong>.',
    localWarning5: '나중에 Google로 로그인하여 데이터를 클라우드로 이동할 수 있습니다.',
    bulkEdit: '일괄 편집',
    selected: '선택됨',
    selectAll: '모두 선택',
    deselectAll: '모두 해제',
    chooseField: '필드 선택',
    bulkEditBarLabel: '일괄 편집',
    chooseValue: '값 선택',
    enterValue: '값 입력...',
    applying: '적용 중...',
    applyToSelected: '적용',
    exitBulkEdit: '일괄 편집 종료',
    bulkEditConfirmTitle: '일괄 편집 확인',
    bulkEditConfirmDesc: '{count}개의 선택한 식물의 {field}을(를) "{value}"(으)로 업데이트하시겠습니까?',
    applyChanges: '변경 적용',
    bulkUpdateSuccess: '{count}개의 식물이 성공적으로 업데이트되었습니다',
    bulkUpdateFailed: '일괄 업데이트 실패',
    deleteSelected: '선택 삭제',
    bulkDeleteConfirmTitle: '일괄 삭제 확인',
    bulkDeleteConfirmDesc: '선택한 {count}개의 식물을 영구적으로 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.',
    bulkDeleteSuccess: '{count}개의 식물이 성공적으로 삭제되었습니다',
    bulkDeleteFailed: '일괄 삭제 실패',
  },
  zh: {
    appName: '我的植物清单',
    appTagline: '您的个人植物护理伙伴。',
    appTagline2: '追踪、识别和照料您的绿色朋友。',
    getStarted: '开始',
    signInPrompt: '使用Google登录以在设备间同步您的植物',
    continueWithGoogle: '使用Google继续',
    or: '或',
    localModeButton: '不用了',
    localWarningTitle: '在不使用账户继续之前：',
    continueLocalMode: '继续本地模式',
    cancelLocalMode: '取消',
    myPlants: '我的植物',
    searchPlants: '搜索植物...',
    noPlants: '还没有植物',
    noPlantsDesc: '点击+按钮添加您的第一株植物！',
    noResults: '没有匹配的植物',
    incomplete: '未完成',
    showing: '显示',
    of: '/',
    plants: '株植物',
    edit: '编辑',
    plant: '株植物',
    addPlant: '添加植物',
    editPlant: '编辑植物',
    addPhoto: '添加照片',
    replacePhoto: '更换照片',
    photoUpdated: '照片已更新',
    photoAdded: '照片已添加',
    photoReplaced: '照片已替换',
    photoUpdateFailed: '照片更新失败',
    batchAdd: '批量添加',
    fromCamera: '从相机',
    mergeIntoAnother: "合并到另一株植物",
    mergeDialogTitle: "合并这两株植物",
    mergeDialogBlurb: "\"保留者\"将留在你的植物库中，吸收另一株植物的所有信息。为每个字段选择哪个值胜出。照片最多合并到5张。",
    mergeDialogBlurbV2: "确认俗名和学名一致，选择要保留的照片和封面。另一株植物将被吸收。",
    mergeKeeper: "保留者",
    mergeAbsorbedTitle: "被吸收（删除）",
    mergeAbsorbed: "被吸收",
    mergeKeepThis: "保留",
    mergePhotos: "张",
    mergeConfirm: "合并植物",
    mergeInProgress: "合并中…",
    mergeFailed: "合并失败",
    mergeSuccess: "植物已合并。",
    mergeSuccessWithDrop: "已合并。{n}张多余照片已丢弃（最多5张）。",
    mergeSameError: "不能将植物与自己合并。",
    mergeDiffHeader: "{n}项养护信息不同 — 请选择",
    mergeNoDiff: "两株植物的养护信息相同 — 无需调整。",
    mergePhotoWarning: "⚠ {n}张多余照片将被丢弃（每株最多5张）。",
    mergeEmpty: "—",
    mergeAction: "合并",
    mergePickerTitle: "合并到另一株植物",
    mergePickerBlurb: "选择应该保留的植物。{name} 将被吸收到该植物中。",
    mergePickerSearch: "按名称搜索…",
    mergePickerSuggested: "可能的重复",
    mergePickerEmpty: "没有其他匹配的植物。",
    mergeSelected: "合并所选",
    mergeRequiresTwo: "请选择恰好2株植物进行合并",
    mergePlantsNotFound: "未找到所选植物",
    duplicateBadge: "重复?",
    duplicateBannerBody: "两条记录共享名称\"{name}\"。合并它们吗?",
    fromGallery: '从相册',
    enterManually: '无照片手动输入',
    doneCropping: '裁剪完成',
    rotate: '旋转',
    cancel: '取消',
    skip: '跳过',
    savePlant: '保存植物',
    saveAndNext: '保存并下一个',
    completeLater: '稍后完成',
    delete: '删除',
    deleting: '删除中...',
    undoChanges: '撤销更改',
    cropInstructions: '如何裁剪：',
    cropDesc: '在图片上点击并拖动以绘制裁剪区域。拖动角落或边缘手柄来调整大小。准备好后点击"裁剪完成"，或跳过以使用完整图片。',
    identifyingPlant: '正在识别植物...',
    looksCorrect: '看起来正确',
    recrop: '重新裁剪',
    notRight: '不正确',
    aiThinksThisIs: 'AI认为这是：',
    wrongEnterCorrectName: '不对？输入正确的名称：',
    pleaseEnterName: '请输入名称',
    aiAutoFill: 'AI自动填充',
    aiAutoFillHint: '在上方输入植物名称，然后点击使用AI自动填充养护信息。',
    addNewPlantTitle: '添加新植物',
    cropAndRotate: '裁剪和旋转照片',
    aiIdentificationTitle: 'AI识别',
    plantDetailsTitle: '植物详情',
    allDone: '全部完成！',
    processedPlants: '已处理{count}株植物：',
    duplicateFound: '发现重复',
    youAlreadyHave: '您的库中已有"{name}"。',
    replaceExisting: '用这个替换现有的',
    keepBoth: '两个都保留',
    discardThisOne: '丢弃这个，保留现有的',
    photoXOfY: '照片 {current}/{total}',
    skippedLabel: '(已跳过)',
    returningToSkipped: '返回跳过的照片...',
    savedAsIncompleteNext: '已保存为未完成。继续...',
    savedAsIncompleteLater: '已保存为未完成。您可以稍后在库中完成。',
    keptExistingNext: '保留了现有的。转到下一张照片...',
    keptExistingPlant: '保留了现有植物。',
    skippedWillReturn: '已跳过 — 稍后再回来',
    removeThisPhoto: '移除这张照片',
    removePhotoTitle: '移除这张照片？',
    removePhotoDesc: '这张照片将被丢弃，不会被添加。本批次中的其他照片仍保留在队列中。',
    removePhotoConfirm: '移除照片',
    photoRemovedWithCount: '照片已移除 — 还剩 {n} 张',
    photoRemoved: '照片已移除',
    photoRestored: '照片已恢复',
    photoDupLibrary: '这张照片已在您的库中，名为"{name}"。您仍可添加或将其移除。',
    photoDupBatch: '您在本批次中已添加过这张照片。您仍可添加或将其移除。',
    anotherPlant: '另一株植物',
    draftDiscarded: '草稿已丢弃',
    draftRestored: '草稿已恢复',
    aiDisclaimer: '护理详情由AI生成（Google Gemini），可能不准确。请根据需要编辑任何字段。',
    aiDisclaimerDetail: '护理详情使用Google Gemini AI生成，可能包含错误。如果科学准确性很重要，请自行研究。',
    commonName: '常用名',
    scientificName: '学名',
    watering: '浇水',
    light: '光照',
    humidity: '湿度',
    temperature: '温度',
    toxicity: '毒性',
    growthRate: '生长速度',
    blooming: '开花',
    bloomSeason: '开花季节',
    bloomDuration: '开花持续时间',
    bloomsIndoors: '室内会开花？',
    bloomTips: '开花小贴士',
    toxicityNotes: '毒性备注',
    dormancyNotes: '休眠期备注',
    bloomLasts: '持续',
    bloomNotIndoors: '室内不开花',
    bloomRarelyIndoors: '室内很少开花',
    dormancy: '休眠期',
    dormantNow: '休眠中',
    needsDormancy: '需要休眠',
    dormancyBannerOne: '本月有 1 株植物进入休眠期。',
    dormancyBannerMany: '本月有 {count} 株植物进入休眠期。',
    dormancyBannerAction: '查看',
    backfillPromptOne: '有1株植物缺少护理详情。',
    backfillPromptMany: '有{count}株植物缺少护理详情。',
    backfillPromptAction: '填写 →',
    iconLegend: '图标说明',
    show: '显示',
    hide: '隐藏',
    legendCareSection: '养护详情',
    legendLibrarySection: '库操作',
    legendFamily: '植物科属（例如天南星科、仙人掌科）。',
    legendPlantType: '生长形态：多肉、藤本、多年生草本等。',
    legendWatering: '浇水的频率和水量。',
    legendLight: '偏好的光照强度（从弱光到全日照）。',
    legendHumidity: '植物适宜的湿度范围。',
    legendTemperature: '理想温度范围（°F 与 °C）。',
    legendToxicity: '对宠物、人或爬行动物是否有毒。',
    legendEnvironment: '普通室内、适合玻璃缸或必须使用玻璃缸。',
    legendGrowthRate: '生长速度：慢、中或快。',
    legendDormancy: '秋冬休眠期 — 落叶或生长变慢属正常现象。',
    aiCareNote: 'AI 提示',
    legendAiNote: 'AI 生成的信息 — 请参考可靠来源核实。',
    legendIncomplete: '稍后补充',
    legendIncompleteHint: '已保存，但缺少照片或养护信息。',
    legendPhoto: '添加 / 替换照片',
    legendPhotoHint: '每株植物最多可添加 5 张照片。',
    legendArchive: '归档',
    legendArchiveHint: '不删除植物，只从主库中移出。',
    legendTerrarium: '玻璃缸筛选',
    legendTerrariumHint: '仅显示需要或偏好玻璃缸的植物。',
    legendDormant: '休眠筛选',
    legendDormantHint: '仅显示当前处于休眠期的植物。',
    legendSearchPlaceholder: '搜索图标…',
    legendNoResults: '没有匹配的图标。',
    environment: '生长环境',
    terrariumOnly: '生态缸植物',
    showAllPlants: '显示所有植物',
    readMore: '查看更多',
    showLess: '收起',
    lastSyncedLabel: '上次同步',
    refreshNow: '立即刷新',
    refreshSyncing: '正在刷新\u2026',
    refreshOffline: '您已离线，请重新连接以刷新。',
    offlineCacheTitle: '离线缓存',
    offlineCacheBlurb: '保存在此设备上的库的只读副本，让你在离线时仍可浏览。',
    offlineCacheStats: '{count} 株植物 \u00b7 {size} \u00b7 保存于 {when}',
    offlineCacheClear: '清除离线缓存',
    offlineCacheCleared: '离线缓存已清除',
    offlineCacheClearFailed: '无法清除离线缓存',
    pendingSyncPill: '{n} 项更改待同步',
    pendingSyncPillOne: '1 项更改待同步',
    pendingSyncTitle: '等待同步的更改',
    pendingSyncBlurbOnline: '这些更改已保存在本设备上，将自动同步。',
    pendingSyncBlurbOffline: '您已离线。重新连接后将立即同步。',
    pendingSyncRetry: '立即重试',
    pendingSyncSyncing: '正在同步\u2026',
    pendingSyncDiscard: '放弃此更改',
    pendingSyncDiscardAll: '全部放弃',
    pendingSyncDiscardAllConfirmTitle: '放弃所有待同步的更改？',
    pendingSyncDiscardAllConfirmBody: '这将移除 {n} 项等待同步的更改，并在此设备上撤销它们。',
    pendingSyncDiscardAllConfirmBodyOne: '这将移除 1 项等待同步的更改，并在此设备上撤销它。',
    pendingSyncDiscardAllToast: '已放弃所有待同步的更改',
    aboutTocTitle: '本页内容',
    pendingSyncViewDetails: '详情',
    allChangesSynced: '所有更改已同步',
    addOfflineNotice: '您已离线：添加新植物需要联网。编辑、归档和删除仍可用，联网后会自动同步。',
    pendingWaitingFor: '等待中 {time}',
    syncProgress: '已同步 {done}/{total}',
    syncHistoryTitle: '最近同步活动',
    syncHistoryClear: '清除',
    syncStatusSynced: '已同步',
    syncStatusConflict: '冲突',
    syncStatusGaveup: '失败',
    syncStatusDiscarded: '已丢弃',
    discardUndo: '撤销',
    changeDiscarded: '已放弃更改',
    syncSyncedOne: '已同步 1 项更改',
    syncSyncedMany: '已同步 {n} 项更改',
    syncConflictOne: '无法同步“{name}”：已在其他设备上更改或删除。',
    syncConflictMany: '{n} 项更改无法同步：这些植物已在其他设备上更改或删除。',
    syncGaveupOne: '多次尝试后已放弃同步“{name}”，请重新操作。',
    syncGaveupMany: '{n} 项更改多次尝试后仍无法保存，已放弃。',
    syncRetryOne: '1 项更改无法同步：将重试',
    syncRetryMany: '{n} 项更改无法同步：将重试',
    offlineHelpTitle: '离线与同步',
    offlineHelpBody: '离线时您可以浏览，并编辑、归档或删除植物——这些更改会排队，联网后自动同步。添加新植物需要联网。',
    offlineHelpLearnMore: '了解更多',
    aboutSharingTitle: '分享你的植物',
    aboutSharingBody: '可将单株植物作为精美图片分享，或将整个植物库作为 PDF 分享——概览（照片+名称）、完整详情（每株一页）或仅名称。每个 PDF 都包含可扫描的二维码、链接和你的欢迎语。接收者会打开只读的“grow-along”视图；你的植物库不会有任何改动，他们也无法编辑。',
    savedOfflineToast: '已离线保存——重新连接后将同步',
    offlineWriteBlocked: '您已离线——请重新连接以保存更改。',
    done: '知道了',
    pendingOpEdit: '编辑\u201c{name}\u201d',
    pendingOpArchive: '归档\u201c{name}\u201d',
    pendingOpDelete: '删除\u201c{name}\u201d',
    pendingOpBulkUpdate: '更新 {count} 株植物',
    pendingOpBulkDelete: '删除 {count} 株植物',
    dateAdded: '添加日期',
    addedOn: '添加于',
    family: '科',
    plantType: '类型',
    careDetails: '护理详情',
    learnMore: '从可靠来源了解更多',
    tapToEnlarge: '点击放大',
    translating: '翻译中...',
    retryTranslation: '重试翻译',
    settings: '设置',
    geminiApiKey: 'Google Gemini API密钥',
    photoQuality: '照片质量',
    fontSize: '字体大小',
    language: '语言',
    languageDesc: '设置应用的显示语言。默认为英语（美国）。',
    saveSettings: '保存设置',
    downloadLibrary: '下载植物库',
    downloadLibraryDesc: 'CSV 最适合重新导入到电子表格或其他工具中。PDF 提供格式化的可打印副本，并正确支持非拉丁文字的植物名称。',
    download: '下载',
    downloading: '下载中…',
    sharePlants: '分享',
    preloadPhotos: '预加载所有照片',
    photosOnDevice: '您的照片已在此设备上',
    noPhotosToPreload: '没有可预加载的照片',
    preloadingPhotos: '正在预加载照片…',
    photosReady: '照片已就绪',
    couldNotLoad: '不可用',
    photoReadFailed: '无法读取该照片，请重新选择',
    aboutAndInstructions: '关于与说明',
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策',
    backToTop: '回到顶部',
    readingProgress: '阅读进度',
    linkCopied: '已复制链接',
    copyLinkToSection: '复制此部分的链接',
    copyPlantLink: '复制分享链接',
    copyLinkFailed: '无法复制链接',
    qrCreateFailed: '无法生成二维码',
    sortNameAsc: '名称（A → Z）',
    sortNameDesc: '名称（Z → A）',
    thenBy: '然后按',
    thenByPlaceholder: '然后按…',
    withPhotos: '含照片',
    noPhotos: '无照片',
    export: '导出CSV',
    signOut: '退出登录',
    back: '返回',
    previous: '上一页',
    next: '下一页',
    page: '页',
    perPage: '每页',
    grouped: '分组',
    by: '按',
    needsAttention: '需要注意',
    toComplete: '待完成',
    found: '已找到',
    updateAll: '全部更新',
    updating: '更新中...',
    dismiss: '关闭',
    missingFamilyType: '缺少科和类型信息。',
    deviceOnlyMode: '仅设备模式',
    plantsUsed: '株植物已使用',
    signInGoogleSync: '使用Google登录以同步',
    connectGoogleDrive: '连接Google Drive',
    connectDriveDesc: '您的植物和照片将安全存储在Google Drive中。这将保护您的数据隐私并在设备间同步。',
    deletePlant: '删除植物',
    deleteConfirmLocal: '确定要删除这株植物吗？这将从您的设备中永久删除它。此操作无法撤销。',
    deleteConfirmDrive: '确定要删除这株植物吗？这将从您的Google Drive中永久删除植物及其照片。此操作无法撤销。',
    exitLocalMode: '退出本地模式',
    logoutTitle: '退出登录',
    logoutConfirmLocal: '您的植物已保存在此设备上，当您返回时仍会在这里。您可以稍后使用Google登录将数据同步到云端。',
    logoutConfirmDrive: '确定要退出登录吗？您需要重新登录才能访问您的植物。',
    exit: '退出',
    tryDifferentSearch: '尝试不同的搜索词',
    noPlantsInstruction: '要查看您的植物库，请使用右下角的橙色按钮添加第一株植物。',
    addNewPlant: '添加新植物',
    normalCards: '标准卡片',
    compactCards: '紧凑卡片',
    listViewLabel: '列表视图',
    unnamedPlant: '未命名植物',
    skipToLibrary: '跳转到植物库',
    saving: '保存中...',
    viewDetails: '查看详情',
    deleteThisPlant: '删除这株植物？',
    loginSubtitle1: '您的个人植物护理伙伴。',
    loginSubtitle2: '追踪、识别和照料您的绿色朋友。',
    loginSignInDesc: '使用Google登录以在设备间同步您的植物',
    idRatherNot: '不用了',
    onDeviceStorage: '设备存储（无需登录）',
    acknowledgeEach: '请在继续之前确认每个项目：',
    continuing: '继续中...',
    continueToLocalMode: '继续本地模式',
    acknowledgeAll: '全部确认',
    aiIdentify: 'AI识别',
    cloudSync: '云同步',
    careTips: '护理提示',
    aiIdentifyDesc: '拍张照片，AI将立即识别您的植物',
    cloudSyncDesc: '您的植物库安全存储在Google云端硬盘中',
    careTipsDesc: '获取个性化的浇水、光照和湿度护理信息',
    localWarning1: '您的植物数据将<strong>仅存储在此设备</strong>的此浏览器中。',
    localWarning2: '<strong>清除浏览器数据将永久删除所有植物。</strong>',
    localWarning3: '限制为<strong>100株植物</strong>（如果设备存储空间不足则更少）。',
    localWarning4: '数据<strong>不会</strong>在设备间同步。',
    localWarning5: '您可以稍后使用Google登录将数据移至云端。',
    bulkEdit: '批量编辑',
    selected: '已选择',
    selectAll: '全选',
    deselectAll: '取消全选',
    chooseField: '选择字段',
    bulkEditBarLabel: '批量编辑',
    chooseValue: '选择值',
    enterValue: '输入值...',
    applying: '应用中...',
    applyToSelected: '应用',
    exitBulkEdit: '退出批量编辑',
    bulkEditConfirmTitle: '确认批量编辑',
    bulkEditConfirmDesc: '将{count}株选中植物的{field}更新为"{value}"？',
    applyChanges: '应用更改',
    bulkUpdateSuccess: '成功更新了{count}株植物',
    bulkUpdateFailed: '批量更新失败',
    deleteSelected: '删除所选',
    bulkDeleteConfirmTitle: '确认批量删除',
    bulkDeleteConfirmDesc: '永久删除{count}株所选植物？此操作无法撤销。',
    bulkDeleteSuccess: '成功删除了{count}株植物',
    bulkDeleteFailed: '批量删除失败',
  },
};

export default translations;
